
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefe68"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefe68"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $748ef63de4ece88b$exports = {};
$parcel$extendImportMap({
    "1zDGa": "mixWorker.50ced5f0.js"
});

class $0cab2659c4542b34$export$2e2bcd8739ae039 {
    constructor(){
        this.listeners = new Map();
    }
    on(event, callback) {
        if (!this.listeners.has(event)) this.listeners.set(event, new Set());
        this.listeners.get(event).add(callback);
        return ()=>this.off(event, callback);
    }
    once(event, callback) {
        const off = this.on(event, (...args)=>{
            off();
            callback(...args);
        });
        return off;
    }
    off(event, callback) {
        if (!this.listeners.has(event)) return;
        const callbacks = this.listeners.get(event);
        callbacks.delete(callback);
        if (!callbacks.size) this.listeners.delete(event);
    }
    emit(event, ...args) {
        if (!this.listeners.has(event)) return;
        [
            ...this.listeners.get(event)
        ].forEach((callback)=>{
            try {
                callback(...args);
            } catch (error) {
                console.error(`[EventBus] Error in listener for ${event}:`, error);
            }
        });
    }
}



class $48dfc7f07cacdd18$export$2e2bcd8739ae039 {
    constructor({ bus: bus = new (0, $0cab2659c4542b34$export$2e2bcd8739ae039)() } = {}){
        this.bus = bus;
        this.devices = [];
        this.screenStream = null;
        this.microphoneStream = null;
        this.cameraStreams = new Map();
        this.deviceListener = null;
    }
    async init() {
        await this.refreshDevices();
        if (navigator.mediaDevices?.addEventListener) {
            this.deviceListener = ()=>this.refreshDevices();
            navigator.mediaDevices.addEventListener("devicechange", this.deviceListener);
        }
    }
    async refreshDevices() {
        try {
            this.devices = await navigator.mediaDevices.enumerateDevices();
            this.bus.emit("devices:updated", this.devices);
            return this.devices;
        } catch (error) {
            console.error("Failed to enumerate devices", error);
            this.bus.emit("devices:error", error);
            throw error;
        }
    }
    getVideoInputs() {
        return this.devices.filter((device)=>device.kind === "videoinput");
    }
    getAudioInputs() {
        return this.devices.filter((device)=>device.kind === "audioinput");
    }
    async getScreenStream(constraints = {}) {
        const defaultConstraints = {
            video: {
                frameRate: {
                    ideal: 30
                },
                width: {
                    ideal: 1920
                },
                height: {
                    ideal: 1080
                },
                ...constraints.video
            },
            audio: constraints.audio ?? false
        };
        try {
            this.screenStream = await navigator.mediaDevices.getDisplayMedia(defaultConstraints);
            this.bus.emit("stream:screen", this.screenStream);
            return this.screenStream;
        } catch (error) {
            if (defaultConstraints.audio) {
                console.warn("getDisplayMedia with audio failed; retrying with audio: false", error);
                try {
                    this.screenStream = await navigator.mediaDevices.getDisplayMedia({
                        video: defaultConstraints.video,
                        audio: false
                    });
                    this.bus.emit("stream:screen", this.screenStream);
                    return this.screenStream;
                } catch (retryError) {
                    this.bus.emit("stream:error", {
                        type: "screen",
                        error: retryError
                    });
                    throw retryError;
                }
            }
            this.bus.emit("stream:error", {
                type: "screen",
                error: error
            });
            throw error;
        }
    }
    async getMicrophoneStream({ deviceId: deviceId, constraints: constraints = {} } = {}) {
        try {
            const defaultConstraints = {
                audio: {
                    echoCancellation: true,
                    noiseSuppression: true,
                    sampleRate: 44100,
                    ...constraints.audio
                },
                video: false
            };
            if (deviceId) defaultConstraints.audio.deviceId = {
                exact: deviceId
            };
            else if (defaultConstraints.audio?.deviceId) {
                if (typeof defaultConstraints.audio.deviceId === "string") defaultConstraints.audio.deviceId = {
                    exact: defaultConstraints.audio.deviceId
                };
            }
            this.microphoneStream = await navigator.mediaDevices.getUserMedia(defaultConstraints);
            this.bus.emit("stream:microphone", this.microphoneStream);
            return this.microphoneStream;
        } catch (error) {
            this.bus.emit("stream:error", {
                type: "microphone",
                error: error
            });
            throw error;
        }
    }
    async getCameraStream(deviceId, constraints = {}) {
        try {
            if (this.cameraStreams.has(deviceId)) return this.cameraStreams.get(deviceId);
            const videoConstraints = {
                width: {
                    ideal: 640,
                    max: 1280
                },
                height: {
                    ideal: 360,
                    max: 720
                },
                frameRate: {
                    ideal: 24,
                    max: 30
                },
                ...constraints.video
            };
            if (deviceId) videoConstraints.deviceId = {
                exact: deviceId
            };
            else if (typeof videoConstraints.deviceId === "string") videoConstraints.deviceId = {
                exact: videoConstraints.deviceId
            };
            const defaultConstraints = {
                audio: false,
                video: videoConstraints
            };
            const stream = await navigator.mediaDevices.getUserMedia(defaultConstraints);
            this.cameraStreams.set(deviceId, stream);
            this.bus.emit("stream:camera", {
                deviceId: deviceId,
                stream: stream
            });
            return stream;
        } catch (error) {
            this.bus.emit("stream:error", {
                type: "camera",
                deviceId: deviceId,
                error: error
            });
            throw error;
        }
    }
    async getCameraStreams(deviceIds = [], constraints = {}) {
        const streams = await Promise.all(deviceIds.map((id)=>this.getCameraStream(id, constraints)));
        return streams;
    }
    releaseCamera(deviceId) {
        if (!this.cameraStreams.has(deviceId)) return;
        this.stopStream(this.cameraStreams.get(deviceId));
        this.cameraStreams.delete(deviceId);
    }
    stopStream(stream) {
        if (!stream) return;
        stream.getTracks().forEach((track)=>track.stop());
    }
    stopAll() {
        this.stopStream(this.screenStream);
        this.stopStream(this.microphoneStream);
        [
            ...this.cameraStreams.entries()
        ].forEach(([deviceId, stream])=>{
            this.stopStream(stream);
            this.cameraStreams.delete(deviceId);
        });
        this.screenStream = null;
        this.microphoneStream = null;
    }
    destroy() {
        this.stopAll();
        if (navigator.mediaDevices?.removeEventListener && this.deviceListener) navigator.mediaDevices.removeEventListener("devicechange", this.deviceListener);
    }
}



const $95b8880beb2cba85$var$PIP_SIZE_RATIO = 0.28;
const $95b8880beb2cba85$var$PIP_MARGIN_RATIO = 0.035;
const $95b8880beb2cba85$var$RECT_ASPECT_RATIO = 16 / 9;
const $95b8880beb2cba85$var$ALLOWED_SHAPES = new Set([
    "square",
    "rectangle"
]);
const $95b8880beb2cba85$var$ALLOWED_POSITIONS = new Set([
    "top-left",
    "top-right",
    "bottom-left",
    "bottom-right"
]);
const $95b8880beb2cba85$var$DEFAULT_PIP_CONFIG = {
    position: "bottom-right",
    shape: "square",
    roundedCorners: true
};
function $95b8880beb2cba85$var$drawVideoContain(ctx, video, x, y, width, height) {
    if (!video || video.readyState < 2) return;
    const videoWidth = video.videoWidth || video.width || 1280;
    const videoHeight = video.videoHeight || video.height || 720;
    if (!videoWidth || !videoHeight) {
        try {
            ctx.drawImage(video, x, y, width, height);
        } catch (e) {
        /* ignore draw error */ }
        return;
    }
    const videoRatio = videoWidth / videoHeight;
    const targetRatio = width / height;
    let renderW = width;
    let renderH = height;
    let renderX = x;
    let renderY = y;
    if (Math.abs(videoRatio - targetRatio) > 0.01) {
        if (videoRatio > targetRatio) {
            renderW = width;
            renderH = width / videoRatio;
            renderY = y + (height - renderH) / 2;
        } else {
            renderH = height;
            renderW = height * videoRatio;
            renderX = x + (width - renderW) / 2;
        }
    }
    try {
        ctx.drawImage(video, 0, 0, videoWidth, videoHeight, renderX, renderY, renderW, renderH);
    } catch (e) {
    /* ignore draw error */ }
}
function $95b8880beb2cba85$var$drawVideoCover(ctx, video, x, y, width, height) {
    if (!video || video.readyState < 2) return;
    const videoWidth = video.videoWidth || video.width || 1280;
    const videoHeight = video.videoHeight || video.height || 720;
    if (!videoWidth || !videoHeight) return;
    const videoRatio = videoWidth / videoHeight;
    const targetRatio = width / height;
    let sx = 0;
    let sy = 0;
    let sWidth = videoWidth;
    let sHeight = videoHeight;
    if (Math.abs(videoRatio - targetRatio) > 0.01) {
        if (videoRatio > targetRatio) {
            sHeight = videoHeight;
            sWidth = sHeight * targetRatio;
            sx = (videoWidth - sWidth) / 2;
        } else {
            sWidth = videoWidth;
            sHeight = sWidth / targetRatio;
            sy = (videoHeight - sHeight) / 2;
        }
    }
    ctx.drawImage(video, sx, sy, sWidth, sHeight, x, y, width, height);
}
function $95b8880beb2cba85$var$drawRoundedRect(ctx, x, y, width, height, radius) {
    const clampedRadius = Math.min(radius, width / 2, height / 2);
    ctx.moveTo(x + clampedRadius, y);
    ctx.lineTo(x + width - clampedRadius, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + clampedRadius);
    ctx.lineTo(x + width, y + height - clampedRadius);
    ctx.quadraticCurveTo(x + width, y + height, x + width - clampedRadius, y + height);
    ctx.lineTo(x + clampedRadius, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - clampedRadius);
    ctx.lineTo(x, y + clampedRadius);
    ctx.quadraticCurveTo(x, y, x + clampedRadius, y);
}
function $95b8880beb2cba85$var$computePipRect(canvas, shape, position) {
    const margin = Math.min(canvas.width, canvas.height) * $95b8880beb2cba85$var$PIP_MARGIN_RATIO;
    let pipWidth = canvas.width * $95b8880beb2cba85$var$PIP_SIZE_RATIO;
    let pipHeight = pipWidth;
    if (shape === "rectangle") pipHeight = pipWidth / $95b8880beb2cba85$var$RECT_ASPECT_RATIO;
    else if (shape === "square") {
        const maxDimension = Math.min(pipWidth, canvas.height * $95b8880beb2cba85$var$PIP_SIZE_RATIO);
        pipWidth = maxDimension;
        pipHeight = maxDimension;
    }
    const maxHeight = canvas.height * 0.42;
    if (pipHeight > maxHeight) {
        const scale = maxHeight / pipHeight;
        pipHeight = maxHeight;
        pipWidth *= scale;
    }
    let x = margin;
    let y = margin;
    switch(position){
        case "top-right":
            x = canvas.width - pipWidth - margin;
            y = margin;
            break;
        case "bottom-left":
            x = margin;
            y = canvas.height - pipHeight - margin;
            break;
        case "bottom-right":
            x = canvas.width - pipWidth - margin;
            y = canvas.height - pipHeight - margin;
            break;
        default:
            // top-left is the default fallback
            x = margin;
            y = margin;
    }
    return {
        x: x,
        y: y,
        width: pipWidth,
        height: pipHeight
    };
}
class $95b8880beb2cba85$export$2e2bcd8739ae039 {
    constructor({ bus: bus = new (0, $0cab2659c4542b34$export$2e2bcd8739ae039)() } = {}){
        this.bus = bus;
        this.layouts = {
            pip: {
                id: "pip",
                label: "Picture-in-Picture",
                description: "Schermo principale con webcam in miniatura personalizzabile",
                requires: {
                    screen: true,
                    cameras: 1
                }
            }
        };
        this.activeLayout = "pip";
        this.activeCameraIndex = 0;
        this.pipConfig = {
            ...$95b8880beb2cba85$var$DEFAULT_PIP_CONFIG
        };
    }
    getLayouts() {
        return Object.values(this.layouts);
    }
    getActiveLayout() {
        return this.layouts[this.activeLayout];
    }
    setLayout(layoutId) {
        if (!this.layouts[layoutId] || this.activeLayout === layoutId) return;
        this.activeLayout = layoutId;
        this.bus.emit("layout:changed", layoutId);
    }
    getPipConfig() {
        return {
            ...this.pipConfig
        };
    }
    setPipShape(shape) {
        if (!$95b8880beb2cba85$var$ALLOWED_SHAPES.has(shape) || this.pipConfig.shape === shape) return;
        this.pipConfig.shape = shape;
        this.bus.emit("layout:pip-config", this.getPipConfig());
    }
    setPipPosition(position) {
        if (!$95b8880beb2cba85$var$ALLOWED_POSITIONS.has(position) || this.pipConfig.position === position) return;
        this.pipConfig.position = position;
        this.bus.emit("layout:pip-config", this.getPipConfig());
    }
    setPipRoundedCorners(enabled) {
        const value = Boolean(enabled);
        if (this.pipConfig.roundedCorners === value) return;
        this.pipConfig.roundedCorners = value;
        this.bus.emit("layout:pip-config", this.getPipConfig());
    }
    setActiveCameraIndex(index) {
        this.activeCameraIndex = index;
        this.bus.emit("layout:camera", index);
    }
    getActiveCameraIndex() {
        return this.activeCameraIndex;
    }
    cycleCamera(cameraCount) {
        if (!cameraCount) return;
        this.activeCameraIndex = (this.activeCameraIndex + 1) % cameraCount;
        this.bus.emit("layout:camera", this.activeCameraIndex);
    }
    getDrawRoutine() {
        return (params)=>this.draw(params);
    }
    draw({ ctx: ctx, canvas: canvas, sources: sources, activeCameraIndex: activeCameraIndex }) {
        if (this.activeLayout === "pip") this.drawPip({
            ctx: ctx,
            canvas: canvas,
            sources: sources,
            activeCameraIndex: activeCameraIndex
        });
    }
    drawPip({ ctx: ctx, canvas: canvas, sources: sources, activeCameraIndex: activeCameraIndex }) {
        const { position: position, shape: shape, roundedCorners: roundedCorners } = this.pipConfig;
        const { width: width, height: height } = canvas;
        const activeCamera = sources.cameras[activeCameraIndex] ?? sources.cameras[0];
        ctx.fillStyle = "#0f172a";
        ctx.fillRect(0, 0, width, height);
        if (sources.screen) $95b8880beb2cba85$var$drawVideoContain(ctx, sources.screen, 0, 0, width, height);
        if (!activeCamera) return;
        const rect = $95b8880beb2cba85$var$computePipRect(canvas, shape, position);
        ctx.save();
        ctx.beginPath();
        const baseRadius = roundedCorners ? Math.min(rect.width, rect.height) * 0.18 : 0;
        $95b8880beb2cba85$var$drawRoundedRect(ctx, rect.x, rect.y, rect.width, rect.height, baseRadius);
        ctx.closePath();
        ctx.clip();
        $95b8880beb2cba85$var$drawVideoCover(ctx, activeCamera, rect.x, rect.y, rect.width, rect.height);
        ctx.restore();
    }
}



const $6a10ece45d415d14$var$DEFAULT_WIDTH = 1920;
const $6a10ece45d415d14$var$DEFAULT_HEIGHT = 1080;
const $6a10ece45d415d14$var$DEFAULT_FRAME_RATE = 30;
function $6a10ece45d415d14$var$supportsWorkerRendering() {
    if (typeof window === "undefined") return false;
    return typeof Worker !== "undefined" && typeof OffscreenCanvas !== "undefined" && typeof HTMLCanvasElement !== "undefined" && typeof HTMLCanvasElement.prototype.transferControlToOffscreen === "function";
}
function $6a10ece45d415d14$var$supportsTrackProcessing() {
    if (typeof window === "undefined") return false;
    return "MediaStreamTrackProcessor" in window && typeof window.MediaStreamTrackProcessor === "function" && "ReadableStream" in window && typeof window.VideoFrame !== "undefined";
}
var $df63cc47855078c6$exports = {};
$df63cc47855078c6$exports = $parcel$resolve("1zDGa");


function $6a10ece45d415d14$var$createWorkerUrl() {
    return new URL($df63cc47855078c6$exports);
}
class $6a10ece45d415d14$export$2e2bcd8739ae039 {
    constructor({ layoutManager: layoutManager, bus: bus = new (0, $0cab2659c4542b34$export$2e2bcd8739ae039)(), width: width, height: height } = {}){
        this.bus = bus;
        this.layoutManager = layoutManager;
        this.canvas = document.createElement("canvas");
        this.canvas.width = width ?? $6a10ece45d415d14$var$DEFAULT_WIDTH;
        this.canvas.height = height ?? $6a10ece45d415d14$var$DEFAULT_HEIGHT;
        this.frameRate = $6a10ece45d415d14$var$DEFAULT_FRAME_RATE;
        this.outputStream = null;
        this.videoSources = {
            screen: null,
            cameras: []
        };
        this.videoFrameCallbacks = new Map();
        this.useWorker = $6a10ece45d415d14$var$supportsWorkerRendering();
        this.worker = null;
        this.offscreenCanvas = null;
        this.workerReady = false;
        this.pendingWorkerMessages = [];
        this.isRunning = false;
        this.ctx = null; // lazily created for fallback mode
        this.trackProcessors = new Map();
        this.trackProcessingSupported = $6a10ece45d415d14$var$supportsTrackProcessing();
        this.fallbackState = {
            animationFrameId: null,
            backgroundRenderInterval: null,
            lastRenderTime: 0,
            frameInterval: 1000 / this.frameRate,
            needsRender: false,
            isRendering: false,
            isDocumentHidden: false
        };
        this.backgroundPumpInterval = null;
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
        this.renderFallback = this.renderFallback.bind(this);
        this.drawFallbackFrame = this.drawFallbackFrame.bind(this);
        this.handleLayoutChange = this.handleLayoutChange.bind(this);
        this.registerLayoutListeners();
    }
    registerLayoutListeners() {
        if (!this.bus?.on) return;
        this.bus.on("layout:camera", this.handleLayoutChange);
        this.bus.on("layout:pip-config", this.handleLayoutChange);
        this.bus.on("layout:changed", this.handleLayoutChange);
    }
    canProcessTracks() {
        return this.useWorker && this.trackProcessingSupported;
    }
    handleLayoutChange() {
        this.sendLayoutState();
    }
    ensureWorkerInitialized() {
        if (!this.useWorker || this.worker) return;
        try {
            const workerUrl = $6a10ece45d415d14$var$createWorkerUrl();
            this.worker = new Worker(workerUrl, {
                type: "module"
            });
            this.workerReady = false;
            this.pendingWorkerMessages = [];
            this.worker.onmessage = (event)=>{
                const { type: type } = event.data || {};
                if (type === "ready") {
                    this.workerReady = true;
                    this.flushPendingWorkerMessages();
                    this.sendLayoutState();
                } else if (type === "disposed") {
                    this.worker = null;
                    this.workerReady = false;
                }
            };
            this.worker.onerror = (error)=>{
                console.error("Mix worker error", error);
                this.fallbackToMainThread();
            };
            this.worker.onmessageerror = (error)=>{
                console.error("Mix worker message error", error);
                this.fallbackToMainThread();
            };
            this.offscreenCanvas = this.canvas.transferControlToOffscreen();
            const payload = {
                canvas: this.offscreenCanvas,
                width: this.canvas.width,
                height: this.canvas.height,
                frameRate: this.frameRate,
                pipConfig: this.layoutManager?.getPipConfig?.(),
                activeCameraIndex: this.layoutManager?.getActiveCameraIndex?.() ?? 0
            };
            this.worker.postMessage({
                type: "init",
                payload: payload
            }, [
                this.offscreenCanvas
            ]);
        } catch (error) {
            console.error("Failed to initialize mix worker", error);
            this.fallbackToMainThread();
        }
    }
    fallbackToMainThread() {
        if (this.worker) try {
            this.worker.terminate();
        } catch (terminateError) {
            console.warn("Unable to terminate mix worker", terminateError);
        }
        this.worker = null;
        this.workerReady = false;
        if (this.pendingWorkerMessages.length) this.pendingWorkerMessages.forEach(({ transfer: transfer })=>{
            transfer?.forEach?.((item)=>{
                try {
                    item.close?.();
                } catch (closeError) {
                    console.debug("Failed to close transferable during fallback", closeError);
                }
            });
        });
        this.pendingWorkerMessages = [];
        this.offscreenCanvas = null;
        this.useWorker = false;
        this.stopAllTrackProcessing();
        if (this.videoSources.screen?.stream && !this.videoSources.screen.video) {
            const video = this.createVideoElement(this.videoSources.screen.stream);
            if (video) {
                video.__mixSourceType = "screen";
                this.videoSources.screen.video = video;
                this.queueVideoFrameCallback(video);
            }
        }
        this.videoSources.cameras = this.videoSources.cameras.map(({ stream: stream, video: video }, index)=>{
            if (video) return {
                stream: stream,
                video: video
            };
            const cameraVideo = this.createVideoElement(stream);
            if (cameraVideo) {
                cameraVideo.__mixSourceType = "camera";
                cameraVideo.__mixCameraIndex = index;
                this.queueVideoFrameCallback(cameraVideo);
            }
            return {
                stream: stream,
                video: cameraVideo
            };
        });
        this.ensureFallbackContext();
    }
    flushPendingWorkerMessages() {
        if (!this.workerReady || !this.worker) return;
        while(this.pendingWorkerMessages.length){
            const { message: message, transfer: transfer } = this.pendingWorkerMessages.shift();
            try {
                this.worker.postMessage(message, transfer);
            } catch (error) {
                console.warn("Failed to post pending worker message", error);
            }
        }
    }
    postWorkerMessage(type, payload = {}, transfer = []) {
        if (!this.worker) return;
        const message = {
            type: type,
            payload: payload
        };
        if (!this.workerReady && type !== "init") {
            if (transfer?.length) {
                transfer.forEach((item)=>{
                    try {
                        item.close?.();
                    } catch (closeError) {
                        console.debug("Unable to release transferable before queue", closeError);
                    }
                });
                return;
            }
            this.pendingWorkerMessages.push({
                message: message,
                transfer: transfer
            });
            return;
        }
        try {
            this.worker.postMessage(message, transfer);
        } catch (error) {
            console.warn("Failed to post message to worker", error);
            if (transfer?.length) transfer.forEach((item)=>{
                try {
                    item.close?.();
                } catch (closeError) {
                    console.debug("Unable to release transferable", closeError);
                }
            });
        }
    }
    ensureFallbackContext() {
        if (!this.ctx) this.ctx = this.canvas.getContext("2d");
    }
    getTrackKey(sourceType, cameraIndex = 0) {
        return `${sourceType}:${cameraIndex ?? 0}`;
    }
    startTrackProcessing({ stream: stream, sourceType: sourceType, cameraIndex: cameraIndex = 0 }) {
        if (!this.canProcessTracks()) return false;
        const track = stream?.getVideoTracks?.()[0];
        if (!track) return false;
        const key = this.getTrackKey(sourceType, cameraIndex);
        this.stopTrackProcessing(key);
        try {
            const Processor = window.MediaStreamTrackProcessor;
            const processor = new Processor({
                track: track
            });
            const reader = processor.readable.getReader();
            const controller = {
                track: track,
                processor: processor,
                reader: reader,
                active: true
            };
            const pump = async ()=>{
                while(controller.active){
                    let result;
                    try {
                        result = await reader.read();
                    } catch (error) {
                        if (controller.active) console.warn("Track processor read error", error);
                        break;
                    }
                    if (!controller.active) {
                        if (result?.value) try {
                            result.value.close();
                        } catch (closeError) {
                            console.debug("Unable to close frame after stop", closeError);
                        }
                        break;
                    }
                    if (!result || result.done) break;
                    const frame = result.value;
                    if (!frame) continue;
                    if (!this.worker || !this.workerReady) {
                        frame.close();
                        continue;
                    }
                    try {
                        this.postWorkerMessage("frame", {
                            sourceType: sourceType,
                            cameraIndex: cameraIndex,
                            frame: frame
                        }, [
                            frame
                        ]);
                    } catch (error) {
                        console.warn("Unable to transfer VideoFrame to worker", error);
                        try {
                            frame.close();
                        } catch (closeError) {
                            console.debug("Failed to close frame after transfer error", closeError);
                        }
                    }
                }
                try {
                    reader.releaseLock();
                } catch (releaseError) {
                    console.debug("Unable to release track reader", releaseError);
                }
            };
            controller.loop = pump();
            this.trackProcessors.set(key, controller);
            return true;
        } catch (error) {
            console.warn("Failed to start track processor", error);
            return false;
        }
    }
    stopTrackProcessing(key) {
        const controller = this.trackProcessors.get(key);
        if (!controller) return;
        controller.active = false;
        try {
            controller.reader.cancel().catch(()=>{});
        } catch (error) {
            console.debug("Track reader cancel failed", error);
        }
        this.trackProcessors.delete(key);
    }
    stopAllTrackProcessing() {
        [
            ...this.trackProcessors.keys()
        ].forEach((key)=>this.stopTrackProcessing(key));
        this.trackProcessors.clear();
    }
    setDimensions({ width: width, height: height }) {
        const shouldResize = Boolean(width || height);
        if (width) this.canvas.width = width;
        if (height) this.canvas.height = height;
        if (!shouldResize) return;
        if (this.useWorker) this.postWorkerMessage("resize", {
            width: this.canvas.width,
            height: this.canvas.height
        });
        else {
            this.ensureFallbackContext();
            this.fallbackState.needsRender = true;
        }
    }
    createVideoElement(stream) {
        if (!stream) return null;
        const video = document.createElement("video");
        video.srcObject = stream;
        video.muted = true;
        video.playsInline = true;
        video.autoplay = true;
        // Keep element with realistic dimensions in layout tree so macOS/Chromium/WebKit
        // compositors do not suspend GPU video decoding when tab is in background.
        video.style.position = "fixed";
        video.style.top = "0";
        video.style.left = "0";
        video.style.width = "320px";
        video.style.height = "180px";
        video.style.opacity = "0.001";
        video.style.pointerEvents = "none";
        video.style.zIndex = "-1000";
        video.setAttribute("aria-hidden", "true");
        const tryPlay = ()=>{
            if (video.paused && video.readyState >= 2) video.play().catch(()=>{
            /* ignore autoplay issues */ });
        };
        video.onloadedmetadata = tryPlay;
        video.oncanplay = tryPlay;
        video.onloadeddata = tryPlay;
        document.body.appendChild(video);
        tryPlay();
        return video;
    }
    destroyVideoElement(video) {
        if (!video) return;
        this.cancelVideoFrameCallback(video);
        if (this.useWorker) {
            const sourceType = video.__mixSourceType;
            const cameraIndex = video.__mixCameraIndex;
            if (sourceType) this.postWorkerMessage("clear-source", {
                sourceType: sourceType,
                cameraIndex: cameraIndex
            });
        }
        video.pause();
        try {
            video.srcObject = null;
        } catch (error) {
        /* ignore */ }
        if (video.parentNode) video.parentNode.removeChild(video);
    }
    setScreenStream(stream) {
        if (this.videoSources.screen) {
            this.stopTrackProcessing(this.getTrackKey("screen"));
            this.destroyVideoElement(this.videoSources.screen.video);
        }
        this.postWorkerMessage("clear-source", {
            sourceType: "screen"
        });
        if (!stream) {
            this.videoSources.screen = null;
            return;
        }
        const processed = this.startTrackProcessing({
            stream: stream,
            sourceType: "screen"
        });
        let video = null;
        if (!processed) {
            video = this.createVideoElement(stream);
            if (video) video.__mixSourceType = "screen";
            this.queueVideoFrameCallback(video);
        }
        this.videoSources.screen = {
            stream: stream,
            video: video
        };
        this.sendLayoutState();
    }
    setCameraStreams(streams = []) {
        this.videoSources.cameras.forEach(({ video: video }, index)=>{
            this.stopTrackProcessing(this.getTrackKey("camera", index));
            this.destroyVideoElement(video);
            this.postWorkerMessage("clear-source", {
                sourceType: "camera",
                cameraIndex: index
            });
        });
        this.videoSources.cameras = streams.filter(Boolean).map((stream, index)=>{
            const processed = this.startTrackProcessing({
                stream: stream,
                sourceType: "camera",
                cameraIndex: index
            });
            let video = null;
            if (!processed) {
                video = this.createVideoElement(stream);
                if (video) {
                    video.__mixSourceType = "camera";
                    video.__mixCameraIndex = index;
                }
                this.queueVideoFrameCallback(video);
            }
            return {
                stream: stream,
                video: video
            };
        });
        this.sendLayoutState();
    }
    getOutputStream({ frameRate: frameRate = $6a10ece45d415d14$var$DEFAULT_FRAME_RATE } = {}) {
        if (Number.isFinite(frameRate) && frameRate > 0) {
            this.frameRate = frameRate;
            this.fallbackState.frameInterval = 1000 / this.frameRate;
            if (this.useWorker) this.postWorkerMessage("start", {
                frameRate: this.frameRate
            });
        }
        if (!this.outputStream) this.outputStream = this.canvas.captureStream(this.frameRate);
        return this.outputStream;
    }
    start({ frameRate: frameRate = $6a10ece45d415d14$var$DEFAULT_FRAME_RATE } = {}) {
        this.isRunning = true;
        if (Number.isFinite(frameRate) && frameRate > 0) {
            this.frameRate = frameRate;
            this.fallbackState.frameInterval = 1000 / this.frameRate;
        }
        if (this.useWorker) {
            this.ensureWorkerInitialized();
            this.postWorkerMessage("start", {
                frameRate: this.frameRate
            });
        } else {
            this.ensureFallbackContext();
            this.fallbackState.needsRender = true;
            if (!this.fallbackState.animationFrameId) this.fallbackState.animationFrameId = requestAnimationFrame(this.renderFallback);
        }
        this.attachVisibilityListener();
        this.sendLayoutState();
        return this.getOutputStream({
            frameRate: this.frameRate
        });
    }
    renderFallback() {
        if (!this.isRunning) {
            this.fallbackState.animationFrameId = null;
            return;
        }
        const now = performance.now();
        if (!this.fallbackState.lastRenderTime) this.fallbackState.lastRenderTime = now;
        const elapsed = now - this.fallbackState.lastRenderTime;
        try {
            if (elapsed >= this.fallbackState.frameInterval || this.fallbackState.needsRender) this.drawFallbackFrame(now);
        } catch (error) {
            console.warn("Fallback render frame failed", error);
        } finally{
            if (this.isRunning) this.fallbackState.animationFrameId = requestAnimationFrame(this.renderFallback);
            else this.fallbackState.animationFrameId = null;
        }
    }
    drawFallbackFrame(now = performance.now()) {
        if (this.fallbackState.isRendering) return;
        this.fallbackState.isRendering = true;
        try {
            this.fallbackState.lastRenderTime = now;
            const drawRoutine = this.layoutManager?.getDrawRoutine?.();
            if (!drawRoutine) return;
            const screenVideo = this.videoSources.screen?.video;
            const cameraVideos = this.videoSources.cameras.map(({ video: video })=>video);
            if (!this.ctx) this.ensureFallbackContext();
            if (!this.ctx) return;
            if (screenVideo || cameraVideos.length) {
                this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
                try {
                    drawRoutine({
                        ctx: this.ctx,
                        canvas: this.canvas,
                        sources: {
                            screen: screenVideo,
                            cameras: cameraVideos
                        },
                        activeCameraIndex: this.layoutManager?.getActiveCameraIndex?.() ?? 0
                    });
                } catch (error) {
                    console.warn("Draw routine failed for this frame", error);
                }
            } else {
                this.ctx.fillStyle = "#0f172a";
                this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
            }
        } finally{
            this.fallbackState.needsRender = false;
            this.fallbackState.isRendering = false;
        }
    }
    queueVideoFrameCallback(video) {
        if (!video || typeof video.requestVideoFrameCallback !== "function") return;
        this.cancelVideoFrameCallback(video);
        const callback = async ()=>{
            this.queueVideoFrameCallback(video);
            if (!this.isRunning) return;
            if (this.useWorker) {
                if (!this.workerReady || !("createImageBitmap" in window)) return;
                if (video.__mixBitmapPending) return;
                video.__mixBitmapPending = true;
                try {
                    const bitmap = await createImageBitmap(video);
                    const payload = {
                        sourceType: video.__mixSourceType,
                        cameraIndex: video.__mixCameraIndex,
                        bitmap: bitmap
                    };
                    this.postWorkerMessage("frame", payload, [
                        bitmap
                    ]);
                } catch (error) {
                    console.warn("Unable to create image bitmap", error);
                } finally{
                    video.__mixBitmapPending = false;
                }
            } else {
                this.fallbackState.needsRender = true;
                if (this.fallbackState.isDocumentHidden) this.drawFallbackFrame();
            }
        };
        const handle = video.requestVideoFrameCallback(callback);
        this.videoFrameCallbacks.set(video, {
            handle: handle,
            callback: callback
        });
    }
    cancelVideoFrameCallback(video) {
        if (!video) return;
        const entry = this.videoFrameCallbacks.get(video);
        if (entry && typeof video.cancelVideoFrameCallback === "function") video.cancelVideoFrameCallback(entry.handle);
        this.videoFrameCallbacks.delete(video);
        if (video.__mixBitmapPending) video.__mixBitmapPending = false;
    }
    clearVideoFrameCallbacks() {
        [
            ...this.videoFrameCallbacks.keys()
        ].forEach((video)=>this.cancelVideoFrameCallback(video));
        this.videoFrameCallbacks.clear();
    }
    sendLayoutState() {
        if (!this.useWorker || !this.workerReady) return;
        const pipConfig = this.layoutManager?.getPipConfig?.();
        const activeCameraIndex = this.layoutManager?.getActiveCameraIndex?.() ?? 0;
        this.postWorkerMessage("layout", {
            pipConfig: pipConfig,
            activeCameraIndex: activeCameraIndex
        });
    }
    attachVisibilityListener() {
        if (typeof document !== "undefined") {
            document.removeEventListener("visibilitychange", this.handleVisibilityChange);
            document.addEventListener("visibilitychange", this.handleVisibilityChange);
            this.handleVisibilityChange();
        }
    }
    detachVisibilityListener() {
        if (typeof document !== "undefined") document.removeEventListener("visibilitychange", this.handleVisibilityChange);
    }
    handleVisibilityChange() {
        if (typeof document === "undefined") return;
        this.fallbackState.isDocumentHidden = document.visibilityState === "hidden";
        if (this.fallbackState.isDocumentHidden) {
            if (!this.useWorker) this.startFallbackBackgroundRender();
            this.startBackgroundFramePump();
        } else {
            if (!this.useWorker) {
                this.stopFallbackBackgroundRender();
                this.fallbackState.needsRender = true;
                if (this.isRunning && !this.fallbackState.animationFrameId) this.fallbackState.animationFrameId = requestAnimationFrame(this.renderFallback);
            }
            this.stopBackgroundFramePump();
        }
    }
    startFallbackBackgroundRender() {
        if (this.useWorker) return;
        if (this.fallbackState.backgroundRenderInterval) return;
        const interval = Math.max(33, Math.floor(this.fallbackState.frameInterval));
        this.fallbackState.backgroundRenderInterval = setInterval(()=>{
            if (!this.fallbackState.isDocumentHidden) return;
            this.drawFallbackFrame();
        }, interval);
    }
    stopFallbackBackgroundRender() {
        if (this.useWorker) return;
        if (!this.fallbackState.backgroundRenderInterval) return;
        clearInterval(this.fallbackState.backgroundRenderInterval);
        this.fallbackState.backgroundRenderInterval = null;
    }
    startBackgroundFramePump() {
        if (this.backgroundPumpInterval) return;
        const interval = Math.max(33, Math.floor(this.fallbackState.frameInterval));
        this.backgroundPumpInterval = setInterval(()=>{
            if (!this.isRunning || !this.fallbackState.isDocumentHidden) return;
            if (this.useWorker && this.worker && this.workerReady) {
                const videosToPump = [];
                if (this.videoSources.screen?.video) videosToPump.push(this.videoSources.screen.video);
                this.videoSources.cameras.forEach(({ video: video })=>{
                    if (video) videosToPump.push(video);
                });
                videosToPump.forEach(async (video)=>{
                    if (!video || video.readyState < 2 || video.__mixBitmapPending) return;
                    video.__mixBitmapPending = true;
                    try {
                        const bitmap = await createImageBitmap(video);
                        const payload = {
                            sourceType: video.__mixSourceType,
                            cameraIndex: video.__mixCameraIndex,
                            bitmap: bitmap
                        };
                        this.postWorkerMessage("frame", payload, [
                            bitmap
                        ]);
                    } catch (error) {
                    // ignore
                    } finally{
                        video.__mixBitmapPending = false;
                    }
                });
            } else if (!this.useWorker) this.drawFallbackFrame();
        }, interval);
    }
    stopBackgroundFramePump() {
        if (this.backgroundPumpInterval) {
            clearInterval(this.backgroundPumpInterval);
            this.backgroundPumpInterval = null;
        }
    }
    stop() {
        this.isRunning = false;
        if (this.useWorker) {
            this.postWorkerMessage("stop");
            this.stopAllTrackProcessing();
        } else {
            if (this.fallbackState.animationFrameId) {
                cancelAnimationFrame(this.fallbackState.animationFrameId);
                this.fallbackState.animationFrameId = null;
            }
            this.stopFallbackBackgroundRender();
        }
        this.stopBackgroundFramePump();
        this.detachVisibilityListener();
        this.clearVideoFrameCallbacks();
        if (this.outputStream) {
            this.outputStream.getTracks().forEach((track)=>track.stop());
            this.outputStream = null;
        }
        this.fallbackState.lastRenderTime = 0;
        this.fallbackState.needsRender = false;
        this.fallbackState.isRendering = false;
        this.fallbackState.isDocumentHidden = false;
    }
    dispose() {
        this.stop();
        this.stopAllTrackProcessing();
        if (this.videoSources.screen) this.destroyVideoElement(this.videoSources.screen.video);
        this.videoSources.cameras.forEach(({ video: video })=>this.destroyVideoElement(video));
        this.videoSources = {
            screen: null,
            cameras: []
        };
        this.clearVideoFrameCallbacks();
        if (this.useWorker) this.postWorkerMessage("clear-source", {});
        this.bus?.emit?.("mix:disposed");
    }
}



const $078752e8bd445664$var$DEFAULT_HOTKEYS = [
    {
        code: "KeyW",
        altKey: true,
        shiftKey: true,
        ctrlKey: false,
        metaKey: false,
        event: "hotkey:next-camera"
    },
    {
        code: "KeyP",
        altKey: true,
        shiftKey: true,
        ctrlKey: false,
        metaKey: false,
        event: "hotkey:primary-camera"
    },
    {
        code: "KeyA",
        altKey: true,
        shiftKey: true,
        ctrlKey: false,
        metaKey: false,
        event: "hotkey:toggle-auto-switch"
    },
    {
        code: "KeyA",
        altKey: false,
        shiftKey: true,
        ctrlKey: false,
        metaKey: false,
        event: "hotkey:toggle-auto-switch"
    }
];
class $078752e8bd445664$export$2e2bcd8739ae039 {
    constructor({ bus: bus = new (0, $0cab2659c4542b34$export$2e2bcd8739ae039)(), layoutManager: layoutManager, hotkeys: hotkeys = $078752e8bd445664$var$DEFAULT_HOTKEYS } = {}){
        this.bus = bus;
        this.layoutManager = layoutManager;
        this.hotkeys = Array.isArray(hotkeys) ? hotkeys : $078752e8bd445664$var$DEFAULT_HOTKEYS;
        this.listener = this.handleKeyPress.bind(this);
        this.enabled = false;
    }
    enable() {
        if (this.enabled) return;
        window.addEventListener("keydown", this.listener, {
            passive: false
        });
        this.enabled = true;
    }
    disable() {
        if (!this.enabled) return;
        window.removeEventListener("keydown", this.listener, {
            passive: false
        });
        this.enabled = false;
    }
    handleKeyPress(event) {
        if (this.shouldIgnoreEvent(event)) return;
        const shortcut = this.hotkeys.find((descriptor)=>this.matchesShortcut(event, descriptor));
        if (!shortcut) return;
        event.preventDefault();
        this.bus.emit(shortcut.event);
    }
    destroy() {
        this.disable();
    }
    matchesShortcut(event, descriptor) {
        if (!descriptor) return false;
        const { code: code, altKey: altKey = false, shiftKey: shiftKey = false, ctrlKey: ctrlKey = false, metaKey: metaKey = false } = descriptor;
        return event.code === code && Boolean(event.altKey) === Boolean(altKey) && Boolean(event.shiftKey) === Boolean(shiftKey) && Boolean(event.ctrlKey) === Boolean(ctrlKey) && Boolean(event.metaKey) === Boolean(metaKey);
    }
    shouldIgnoreEvent(event) {
        const target = event.target;
        if (!target) return false;
        const tagName = target.tagName;
        if (!tagName) return false;
        const normalized = tagName.toLowerCase();
        if (normalized === "input" || normalized === "textarea" || normalized === "select") return target.type !== "checkbox" && target.type !== "radio";
        return Boolean(target.isContentEditable);
    }
}


const $920a45577759f24a$var$DB_NAME = "ScreenRecRecoveryDB";
const $920a45577759f24a$var$DB_VERSION = 1;
let $920a45577759f24a$var$dbInstance = null;
function $920a45577759f24a$var$initDb() {
    if ($920a45577759f24a$var$dbInstance) return Promise.resolve($920a45577759f24a$var$dbInstance);
    return new Promise((resolve, reject)=>{
        try {
            const request = indexedDB.open($920a45577759f24a$var$DB_NAME, $920a45577759f24a$var$DB_VERSION);
            request.onerror = (event)=>{
                console.error("IndexedDB error:", event.target.error);
                reject(event.target.error);
            };
            request.onsuccess = (event)=>{
                $920a45577759f24a$var$dbInstance = event.target.result;
                resolve($920a45577759f24a$var$dbInstance);
            };
            request.onupgradeneeded = (event)=>{
                const db = event.target.result;
                if (!db.objectStoreNames.contains("metadata")) db.createObjectStore("metadata", {
                    keyPath: "id"
                });
                if (!db.objectStoreNames.contains("chunks")) db.createObjectStore("chunks", {
                    keyPath: "id"
                });
            };
        } catch (e) {
            console.error("IndexedDB not supported or blocked", e);
            reject(e);
        }
    });
}
const $920a45577759f24a$export$638493c32a77e76d = {
    async startNewSession (mime, filename) {
        try {
            const db = await $920a45577759f24a$var$initDb();
            const sessionId = `rec_${Date.now()}`;
            // Clear old data first
            await this.clearStorage();
            return new Promise((resolve, reject)=>{
                const tx = db.transaction([
                    "metadata"
                ], "readwrite");
                const store = tx.objectStore("metadata");
                const metadata = {
                    id: "session",
                    sessionId: sessionId,
                    mime: mime,
                    filename: filename,
                    status: "recording",
                    timestamp: Date.now()
                };
                const request = store.put(metadata);
                request.onsuccess = ()=>resolve(sessionId);
                request.onerror = (e)=>reject(e.target.error);
            });
        } catch (error) {
            console.error("Failed to start new session in IndexedDB", error);
            return null;
        }
    },
    async appendChunk (sessionId, index, blob) {
        try {
            const db = await $920a45577759f24a$var$initDb();
            return new Promise((resolve, reject)=>{
                const tx = db.transaction([
                    "chunks"
                ], "readwrite");
                const store = tx.objectStore("chunks");
                const chunkRecord = {
                    id: `${sessionId}_${index}`,
                    sessionId: sessionId,
                    index: index,
                    blob: blob
                };
                const request = store.put(chunkRecord);
                request.onsuccess = ()=>resolve(true);
                request.onerror = (e)=>reject(e.target.error);
            });
        } catch (error) {
            console.error("Failed to append chunk to IndexedDB", error);
            throw error;
        }
    },
    async markSessionCompleted (sessionId) {
        try {
            const db = await $920a45577759f24a$var$initDb();
            return new Promise((resolve, reject)=>{
                const tx = db.transaction([
                    "metadata"
                ], "readwrite");
                const store = tx.objectStore("metadata");
                const getReq = store.get("session");
                getReq.onsuccess = ()=>{
                    const metadata = getReq.result;
                    if (metadata && metadata.sessionId === sessionId) {
                        metadata.status = "completed";
                        const putReq = store.put(metadata);
                        putReq.onsuccess = ()=>resolve();
                        putReq.onerror = (e)=>reject(e.target.error);
                    } else resolve();
                };
                getReq.onerror = (e)=>reject(e.target.error);
            });
        } catch (error) {
            console.error("Failed to mark session completed in IndexedDB", error);
        }
    },
    async getCurrentSession () {
        try {
            const db = await $920a45577759f24a$var$initDb();
            return new Promise((resolve, reject)=>{
                const tx = db.transaction([
                    "metadata"
                ], "readonly");
                const store = tx.objectStore("metadata");
                const request = store.get("session");
                request.onsuccess = ()=>resolve(request.result || null);
                request.onerror = (e)=>reject(e.target.error);
            });
        } catch (error) {
            console.error("Failed to get current session from IndexedDB", error);
            return null;
        }
    },
    async getSessionChunks (sessionId) {
        try {
            const db = await $920a45577759f24a$var$initDb();
            return new Promise((resolve, reject)=>{
                const tx = db.transaction([
                    "chunks"
                ], "readonly");
                const store = tx.objectStore("chunks");
                const request = store.getAll();
                request.onsuccess = ()=>{
                    const allChunks = request.result || [];
                    const filtered = allChunks.filter((c)=>c.sessionId === sessionId).sort((a, b)=>a.index - b.index).map((c)=>c.blob);
                    resolve(filtered);
                };
                request.onerror = (e)=>reject(e.target.error);
            });
        } catch (error) {
            console.error("Failed to get session chunks from IndexedDB", error);
            return [];
        }
    },
    async clearStorage () {
        try {
            const db = await $920a45577759f24a$var$initDb();
            return new Promise((resolve, reject)=>{
                const tx = db.transaction([
                    "metadata",
                    "chunks"
                ], "readwrite");
                const metaStore = tx.objectStore("metadata");
                const chunksStore = tx.objectStore("chunks");
                metaStore.clear();
                chunksStore.clear();
                tx.oncomplete = ()=>resolve();
                tx.onerror = (e)=>reject(e.target.error);
            });
        } catch (error) {
            console.error("Failed to clear IndexedDB storage", error);
        }
    }
};


const $cb4d6b01942e8622$var$CAMERA_LIMIT = 2;
const $cb4d6b01942e8622$var$AUTO_SWITCH_MIN_DEFAULT = 2; // minutes
const $cb4d6b01942e8622$var$AUTO_SWITCH_MAX_DEFAULT = 5; // minutes
const $cb4d6b01942e8622$var$AUTO_SWITCH_SPOTLIGHT_DEFAULT = 25; // seconds
class $cb4d6b01942e8622$export$2e2bcd8739ae039 {
    constructor(){
        if ($cb4d6b01942e8622$export$2e2bcd8739ae039.instance) return $cb4d6b01942e8622$export$2e2bcd8739ae039.instance;
        this.bus = new (0, $0cab2659c4542b34$export$2e2bcd8739ae039)();
        this.layoutManager = new (0, $95b8880beb2cba85$export$2e2bcd8739ae039)({
            bus: this.bus
        });
        this.streamManager = new (0, $48dfc7f07cacdd18$export$2e2bcd8739ae039)({
            bus: this.bus
        });
        this.mixEngine = new (0, $6a10ece45d415d14$export$2e2bcd8739ae039)({
            layoutManager: this.layoutManager,
            bus: this.bus
        });
        this.hotkeys = new (0, $078752e8bd445664$export$2e2bcd8739ae039)({
            bus: this.bus,
            layoutManager: this.layoutManager
        });
        this.state = {
            mime: typeof MediaRecorder !== "undefined" && MediaRecorder.isTypeSupported("video/mp4") ? "mp4" : "webm",
            filename: "",
            captureMode: null,
            isRecording: false,
            isPause: false,
            selectedCameras: [],
            selectedMicrophone: null,
            primaryCameraId: null,
            autoSwitchEnabled: false,
            autoSwitchMinMinutes: $cb4d6b01942e8622$var$AUTO_SWITCH_MIN_DEFAULT,
            autoSwitchMaxMinutes: $cb4d6b01942e8622$var$AUTO_SWITCH_MAX_DEFAULT,
            autoSwitchSpotlightSeconds: $cb4d6b01942e8622$var$AUTO_SWITCH_SPOTLIGHT_DEFAULT,
            autoSwitchTimer: null,
            autoSwitchTimerEndsAt: null,
            autoSwitchSpotlightTimer: null,
            autoSwitchSpotlightEndsAt: null,
            autoSwitchMode: "idle",
            autoSwitchCurrentSecondary: null,
            autoSwitchLastSecondary: null
        };
        this.audioContext = null;
        this.mixedAudioDestination = null;
        this.recordedChunks = [];
        this.currentSessionId = null;
        this.chunkIndex = 0;
        this.storageFailed = false;
        this.pendingChunkWrites = [];
        this.lastRecordingUrl = null;
        this.wakeLockSentinel = null;
        this.wakeLockRetryTimeout = null;
        this.wakeLockVisibilityListenerAttached = false;
        this.audioSources = [];
        this.cameraPreviewElements = new Map();
        this.primaryCameraPreview = null;
        this.recordingStartTime = null;
        this.recordingTimerInterval = null;
        this.autoSwitchCountdownInterval = null;
        this.set = {
            start: document.getElementById("start"),
            stop: document.getElementById("stop"),
            pauseAndResume: document.getElementById("pauseAndResume"),
            preview: document.querySelector("#preview"),
            download: document.querySelector("#download"),
            recordingName: document.querySelector("#filename"),
            videoWrapper: document.querySelector(".sh__video--wrp"),
            dropdownToggle: document.querySelector(".sh__dropdown--btn"),
            dropdownList: document.querySelector(".sh__dropdown__list"),
            dropdownDefaultOption: document.querySelector(".sh__dropdown--defaultOption"),
            dropdownOptions: document.querySelectorAll(".sh__dropdown__list--item"),
            dropdownChevron: document.querySelector(".sh__dropdown--icon.chevron"),
            headerText: document.querySelector(".sh__header"),
            toast: document.getElementById("toast"),
            cameraList: document.getElementById("cameraList"),
            cameraPreviewGrid: document.getElementById("cameraPreviewGrid"),
            cameraPrimaryFrame: document.querySelector(".sh__camera-primary-frame"),
            cameraStudio: document.getElementById("cameraStudio"),
            cameraStudioToggle: document.getElementById("cameraStudioToggle"),
            cameraStudioPanel: document.getElementById("cameraStudioPanel"),
            pipShapeControls: document.getElementById("pipShapeControls"),
            pipPositionControls: document.getElementById("pipPositionControls"),
            pipCornersToggle: document.getElementById("pipCornersToggle"),
            microphoneStudio: document.getElementById("microphoneStudio"),
            microphoneStudioToggle: document.getElementById("microphoneStudioToggle"),
            microphoneStudioPanel: document.getElementById("microphoneStudioPanel"),
            microphoneList: document.getElementById("microphoneList"),
            autoSwitchToggle: document.getElementById("autoSwitchToggle"),
            autoSwitchToggleWrapper: document.querySelector('label.sh__toggle[for="autoSwitchToggle"]'),
            autoSwitchMin: document.getElementById("autoSwitchMin"),
            autoSwitchMax: document.getElementById("autoSwitchMax"),
            autoSwitchDuration: document.getElementById("autoSwitchDuration"),
            autoSwitchCard: document.querySelector(".sh__studio-card--autoswitch"),
            cameraPreviewLegend: document.querySelector(".sh__camera-preview-legend"),
            cameraPreviewHint: document.querySelector(".sh__studio-card__hint--preview"),
            pipPreview: document.getElementById("pipPreview"),
            recordingInfo: document.querySelector(".sh__recording-info"),
            recordingTimer: document.querySelector(".sh__recording-timer__value"),
            recordingSwitch: document.querySelector(".sh__recording-switch"),
            recordingSwitchValue: document.querySelector(".sh__recording-switch__value"),
            recordingControls: document.querySelector(".sh__recording-controls"),
            reviewControls: document.querySelector(".sh__review-controls"),
            discardButton: document.getElementById("discard"),
            logo: document.querySelector(".sh__logo"),
            choice: document.querySelector(".sh__choice"),
            footer: document.querySelector(".sh__footer"),
            recoveryCard: document.getElementById("recoveryCard"),
            recoverBtn: document.getElementById("recoverBtn"),
            discardRecoveryBtn: document.getElementById("discardRecoveryBtn"),
            mimeChoiceWrapper: document.getElementById("mimeChoiceWrapper"),
            formatMp4: document.getElementById("formatMp4"),
            formatWebm: document.getElementById("formatWebm"),
            formatNotice: document.getElementById("formatNotice")
        };
        this.handleDevicesUpdate = this.handleDevicesUpdate.bind(this);
        this.handleCameraSelectionChange = this.handleCameraSelectionChange.bind(this);
        this.handleAutoSwitchToggle = this.handleAutoSwitchToggle.bind(this);
        this.handleAutoSwitchMinChange = this.handleAutoSwitchMinChange.bind(this);
        this.handleAutoSwitchMaxChange = this.handleAutoSwitchMaxChange.bind(this);
        this.handleAutoSwitchDurationChange = this.handleAutoSwitchDurationChange.bind(this);
        this.handleCameraToggle = this.handleCameraToggle.bind(this);
        this.handleCaptureModeChange = this.handleCaptureModeChange.bind(this);
        this.handleMicrophoneToggle = this.handleMicrophoneToggle.bind(this);
        this.handleMicrophoneSelectionChange = this.handleMicrophoneSelectionChange.bind(this);
        this.handlePipShapeClick = this.handlePipShapeClick.bind(this);
        this.handlePipPositionClick = this.handlePipPositionClick.bind(this);
        this.handlePipCornersToggle = this.handlePipCornersToggle.bind(this);
        this.syncPipControls = this.syncPipControls.bind(this);
        this.handleWakeLockRelease = this.handleWakeLockRelease.bind(this);
        this.handleWakeLockVisibilityChange = this.handleWakeLockVisibilityChange.bind(this);
        this.beforeUnloadHandler = this.beforeUnloadHandler.bind(this);
        this.bus.on("devices:updated", this.handleDevicesUpdate);
        this.bus.on("hotkey:next-camera", ()=>this.cycleActiveCamera());
        this.bus.on("hotkey:primary-camera", ()=>this.handlePrimaryCameraHotkey());
        this.bus.on("hotkey:toggle-auto-switch", ()=>this.handleAutoSwitchHotkey());
        this.bus.on("layout:camera", ()=>this.renderCameraPreviewGrid());
        this.bus.on("layout:changed", ()=>this.renderCameraPreviewGrid());
        this.bus.on("layout:pip-config", this.syncPipControls);
        $cb4d6b01942e8622$export$2e2bcd8739ae039.instance = this;
    }
    async init() {
        const permissionsReady = await this.ensureInitialPermissions();
        if (!permissionsReady) return;
        await this.streamManager.init();
        this.hotkeys.enable();
        this.layoutManager.setLayout("pip");
        this.layoutManager.setActiveCameraIndex(0);
        this.registerDropdown();
        this.registerFilenameInput();
        this.registerFormatSelector();
        this.registerCameraStudioControls();
        this.registerMicrophoneControls();
        this.registerPrimaryControls();
        this.registerLayoutControls();
        this.registerAutoSwitchControls();
        this.handleCaptureModeChange();
        this.syncPipControls(this.layoutManager.getPipConfig());
        await this.checkRecoveryOnStartup();
    }
    async ensureInitialPermissions() {
        if (typeof navigator === "undefined" || !navigator.mediaDevices?.getUserMedia) return true;
        const PERMISSION_STATUS_KEY = "screenrec:permissionsStatus";
        const PERMISSION_RELOAD_KEY = "screenrec:permissionsReload";
        let storage = null;
        try {
            storage = window?.sessionStorage ?? null;
        } catch (error) {
            console.debug("[PERMISSIONS] Session storage non disponibile", error);
        }
        if (storage?.getItem(PERMISSION_RELOAD_KEY) === "pending") {
            storage.setItem(PERMISSION_RELOAD_KEY, "done");
            return true;
        }
        const status = storage?.getItem(PERMISSION_STATUS_KEY);
        if (status === "granted" || status === "denied") return true;
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                audio: true,
                video: true
            });
            stream.getTracks().forEach((track)=>track.stop());
            if (storage) {
                storage.setItem(PERMISSION_STATUS_KEY, "granted");
                storage.setItem(PERMISSION_RELOAD_KEY, "pending");
            }
            window.location.reload();
            return false;
        } catch (error) {
            console.warn("[PERMISSIONS] Impossibile ottenere i permessi iniziali", error);
            storage?.setItem(PERMISSION_STATUS_KEY, "denied");
            this.appendStatusNotification("error", "Consenti l'accesso a webcam e microfono dalle impostazioni del browser per usare tutte le funzioni.");
            return true;
        }
    }
    registerFilenameInput() {
        const filenameInput = document.getElementById("filename");
        if (!filenameInput) return;
        if (!filenameInput.value) {
            const now = new Date();
            const dateStr = now.toLocaleDateString("it-IT").replace(/\//g, "-");
            const timeStr = now.toLocaleTimeString("it-IT", {
                hour: "2-digit",
                minute: "2-digit"
            });
            filenameInput.value = `Registrazione del ${dateStr} ore ${timeStr}`;
        }
        filenameInput.addEventListener("input", ()=>{
            const hasName = filenameInput.value.trim().length > 0;
            const hasMode = Boolean(this.state.captureMode);
            if (hasName && hasMode) {
                this.set.microphoneStudio?.classList.remove("force-hidden");
                this.set.cameraStudio?.classList.remove("force-hidden");
                this.set.start?.classList.remove("force-hidden");
                this.handleCaptureModeChange();
            } else {
                this.set.microphoneStudio?.classList.add("force-hidden");
                this.set.cameraStudio?.classList.add("force-hidden");
                this.set.start?.classList.add("force-hidden");
            }
        });
        // Make the filename field container visible if captureMode is already set
        if (this.state.captureMode) this.set.recordingName.classList.add("visible");
    }
    registerFormatSelector() {
        const mp4Supported = typeof MediaRecorder !== "undefined" && MediaRecorder.isTypeSupported("video/mp4");
        // --- Fallback se MP4 non è supportato (es. Firefox) ---
        if (!mp4Supported) {
            this.state.mime = "webm";
            if (this.set.formatMp4) {
                this.set.formatMp4.disabled = true;
                this.set.formatMp4.classList.remove("active");
                this.set.formatMp4.title = "MP4 non \xe8 supportato da questo browser";
            }
            if (this.set.formatWebm) this.set.formatWebm.classList.add("active");
            if (this.set.formatNotice) this.set.formatNotice.textContent = "\u26A0\uFE0F MP4 non supportato: verr\xe0 usato WebM";
        } else {
            // MP4 supportato: imposta lo stato visivo iniziale corretto (MP4 attivo)
            this.state.mime = "mp4";
            if (this.set.formatMp4) this.set.formatMp4.classList.add("active");
            if (this.set.formatWebm) this.set.formatWebm.classList.remove("active");
        }
        // --- Click listener pulsante MP4 ---
        this.set.formatMp4?.addEventListener("click", ()=>{
            if (this.set.formatMp4.disabled) return;
            this.state.mime = "mp4";
            this.set.formatMp4.classList.add("active");
            this.set.formatWebm?.classList.remove("active");
            if (this.set.formatNotice) this.set.formatNotice.textContent = "";
        });
        // --- Click listener pulsante WebM ---
        this.set.formatWebm?.addEventListener("click", ()=>{
            this.state.mime = "webm";
            this.set.formatWebm.classList.add("active");
            this.set.formatMp4?.classList.remove("active");
            if (this.set.formatNotice) this.set.formatNotice.textContent = "";
        });
    }
    registerDropdown() {
        if (!this.set.dropdownToggle) return;
        this.set.dropdownToggle.addEventListener("click", ()=>{
            this.toggleDropdown();
        });
        document.addEventListener("click", (e)=>{
            if (this.set.dropdownToggle.classList.contains("toggled")) {
                if (!e.target.closest(".sh__dropdown--btn")) this.toggleDropdown();
            }
        });
        this.set.dropdownOptions.forEach((el)=>{
            el.addEventListener("click", ()=>{
                this.set.recordingName.classList.add("visible");
                // Also show parent container/label if exists
                const container = this.set.recordingName.closest(".sh__filename-container");
                if (container) container.classList.add("visible");
                // Show format selector
                this.set.mimeChoiceWrapper?.classList.remove("force-hidden");
                this.set.mimeChoiceWrapper?.classList.add("visible");
                this.state.captureMode = this.getSelectedValue(el);
                this.toggleDropdown();
                this.handleCaptureModeChange();
                // Dispatch input event to immediately display studios/start button
                this.set.recordingName.dispatchEvent(new Event("input"));
            });
        });
    }
    registerCameraStudioControls() {
        if (!this.set.cameraStudio || !this.set.cameraStudioToggle) return;
        if (!this.set.cameraStudio.dataset.open) this.set.cameraStudio.dataset.open = "false";
        this.set.cameraStudioToggle.setAttribute("aria-expanded", "false");
        this.set.cameraStudioToggle.disabled = true;
        this.set.cameraStudioToggle.setAttribute("aria-disabled", "true");
        this.set.cameraStudioPanel?.setAttribute("aria-hidden", "true");
        this.set.cameraStudioToggle.addEventListener("click", this.handleCameraToggle);
        const hasCameras = this.streamManager.getVideoInputs().length > 0;
        this.updateCameraStudioAvailability(hasCameras);
    }
    handleCameraToggle() {
        const isOpen = this.set.cameraStudio?.dataset.open === "true";
        this.setCameraStudioOpen(!isOpen);
    }
    updateCameraStudioAvailability(hasCameras) {
        if (!this.set.cameraStudio) return;
        const shouldShow = hasCameras && this.includesCameraSources();
        if (shouldShow) {
            this.set.cameraStudio.classList.remove("hidden");
            this.set.cameraStudio.removeAttribute("aria-hidden");
            if (this.set.cameraStudioToggle) {
                this.set.cameraStudioToggle.disabled = false;
                this.set.cameraStudioToggle.setAttribute("aria-disabled", "false");
            }
        } else {
            this.setCameraStudioOpen(false);
            this.set.cameraStudio.classList.add("hidden");
            this.set.cameraStudio.setAttribute("aria-hidden", "true");
            if (this.set.cameraStudioToggle) {
                this.set.cameraStudioToggle.disabled = true;
                this.set.cameraStudioToggle.setAttribute("aria-disabled", "true");
            }
        }
    }
    setCameraStudioOpen(isOpen) {
        if (!this.set.cameraStudio) return;
        this.set.cameraStudio.dataset.open = isOpen ? "true" : "false";
        this.set.cameraStudioToggle?.setAttribute("aria-expanded", String(isOpen));
        this.set.cameraStudioPanel?.setAttribute("aria-hidden", String(!isOpen));
    }
    clearCameraPreviews() {
        this.cameraPreviewElements.forEach((video)=>{
            video.srcObject?.getTracks().forEach((track)=>track.stop());
            video.remove();
        });
        this.cameraPreviewElements.clear();
        if (this.set.cameraPreviewGrid) this.set.cameraPreviewGrid.innerHTML = `<p class="sh__studio-hint">Collega una webcam per iniziare.</p>`;
        this.updatePrimaryCameraPreview();
    }
    clearSelectedCameras() {
        this.stopAutoSwitchTimer();
        this.state.autoSwitchEnabled = false;
        if (this.set.autoSwitchToggle) this.set.autoSwitchToggle.checked = false;
        this.state.selectedCameras.forEach((deviceId)=>this.streamManager.releaseCamera(deviceId));
        this.state.selectedCameras = [];
        this.state.primaryCameraId = null;
        if (this.set.cameraList) this.set.cameraList.querySelectorAll('input[type="checkbox"]').forEach((box)=>{
            box.checked = false;
        });
        this.clearCameraPreviews();
    }
    ensurePrimaryCamera() {
        if (!this.state.selectedCameras.length) {
            this.state.primaryCameraId = null;
            this.updatePrimaryCameraPreview();
            return;
        }
        if (!this.state.primaryCameraId || !this.state.selectedCameras.includes(this.state.primaryCameraId)) this.state.primaryCameraId = this.state.selectedCameras[0];
        this.updatePrimaryCameraPreview();
    }
    getPrimaryCameraIndex() {
        if (!this.state.primaryCameraId) return -1;
        return this.state.selectedCameras.indexOf(this.state.primaryCameraId);
    }
    updateAutoSwitchUIState() {
        const hasCameraMode = this.includesCameraSources();
        const hasAnyCamera = this.state.selectedCameras.length > 0;
        const hasSecondary = this.hasSecondaryCameras();
        const canToggle = hasCameraMode && hasSecondary;
        const isMultiCam = hasCameraMode && hasSecondary;
        if (this.set.cameraStudio) this.set.cameraStudio.dataset.multiWebcam = isMultiCam ? "true" : "false";
        if (this.set.autoSwitchCard) this.set.autoSwitchCard.style.display = isMultiCam ? "" : "none";
        if (this.set.cameraPreviewLegend) this.set.cameraPreviewLegend.style.display = isMultiCam ? "" : "none";
        if (this.set.cameraPreviewHint) this.set.cameraPreviewHint.style.display = isMultiCam ? "" : "none";
        console.log("[AUTO-SWITCH] UI update:", {
            hasCameraMode: hasCameraMode,
            hasAnyCamera: hasAnyCamera,
            hasSecondary: hasSecondary,
            canToggle: canToggle,
            isMultiCam: isMultiCam,
            autoSwitchEnabled: this.state.autoSwitchEnabled,
            selectedCameras: this.state.selectedCameras.length,
            primaryCameraId: this.state.primaryCameraId
        });
        if (!canToggle && this.state.autoSwitchEnabled) {
            console.warn("[AUTO-SWITCH] Force disabling due to conditions not met");
            this.state.autoSwitchEnabled = false;
            this.stopAutoSwitchTimer();
        }
        if (this.set.autoSwitchToggle) {
            this.set.autoSwitchToggle.disabled = !canToggle;
            this.set.autoSwitchToggle.checked = this.state.autoSwitchEnabled;
        }
        if (this.set.autoSwitchToggleWrapper) {
            const wrapperState = !hasCameraMode ? "camera-required" : hasSecondary ? "ready" : hasAnyCamera ? "needs-secondary" : "no-camera";
            this.set.autoSwitchToggleWrapper.classList.toggle("is-disabled", !canToggle);
            this.set.autoSwitchToggleWrapper.dataset.state = wrapperState;
        }
        const disableInputs = !hasCameraMode || !hasSecondary;
        if (this.set.autoSwitchMin) {
            this.set.autoSwitchMin.disabled = disableInputs;
            if (!disableInputs) this.set.autoSwitchMin.value = this.state.autoSwitchMinMinutes;
        }
        if (this.set.autoSwitchMax) {
            this.set.autoSwitchMax.disabled = disableInputs;
            if (!disableInputs) this.set.autoSwitchMax.value = this.state.autoSwitchMaxMinutes;
        }
        if (this.set.autoSwitchDuration) {
            this.set.autoSwitchDuration.disabled = disableInputs;
            if (!disableInputs) this.set.autoSwitchDuration.value = this.state.autoSwitchSpotlightSeconds;
        }
    }
    resetMicrophoneSelection() {
        this.state.selectedMicrophone = null;
        if (this.set.microphoneList) this.set.microphoneList.querySelectorAll('input[type="radio"]').forEach((radio)=>{
            radio.checked = false;
        });
    }
    ensureDefaultMicrophoneSelection(audioInputs = []) {
        if (!this.includesMicrophoneSource()) return;
        const available = audioInputs.length ? audioInputs : this.streamManager.getAudioInputs();
        if (!available.length) return;
        const availableIds = available.map((d)=>d.deviceId);
        if (!this.state.selectedMicrophone || !availableIds.includes(this.state.selectedMicrophone)) this.state.selectedMicrophone = available[0].deviceId;
        if (this.set.microphoneList) {
            const radio = this.set.microphoneList.querySelector(`input[type="radio"][value="${this.state.selectedMicrophone}"]`);
            if (radio) radio.checked = true;
        }
    }
    populateMicrophoneList(audioInputs = []) {
        if (!this.set.microphoneList) return;
        if (!audioInputs.length) {
            this.set.microphoneList.innerHTML = `<li class="sh__mic-list--empty">Nessun microfono rilevato</li>`;
            return;
        }
        if (this.includesMicrophoneSource() && (!this.state.selectedMicrophone || !audioInputs.some((d)=>d.deviceId === this.state.selectedMicrophone))) this.state.selectedMicrophone = audioInputs[0].deviceId;
        const selectedId = this.state.selectedMicrophone;
        this.set.microphoneList.innerHTML = audioInputs.map((device, index)=>{
            const label = device.label || `Microfono ${index + 1}`;
            const isChecked = selectedId === device.deviceId ? "checked" : "";
            return `
          <li class="sh__mic-list--item">
            <label class="sh__device-card">
              <input type="radio" name="microphoneSource" value="${device.deviceId}" ${isChecked} />
              <span class="sh__device-card-indicator"></span>
              <span class="sh__device-card-icon">\u{1F399}\u{FE0F}</span>
              <span class="sh__device-card-info">
                <span class="sh__device-card-title">${label}</span>
                <span class="sh__device-card-subtitle">Dispositivo audio</span>
              </span>
              <span class="sh__mic-level" aria-hidden="true"></span>
            </label>
          </li>
        `;
        }).join("");
    }
    syncMicrophoneSelection(audioInputs = []) {
        if (!this.set.microphoneList) return;
        if (!audioInputs.length) return;
        const selectedId = this.state.selectedMicrophone;
        if (!selectedId) return;
        const radio = this.set.microphoneList.querySelector(`input[type="radio"][value="${selectedId}"]`);
        if (radio) radio.checked = true;
    }
    includesCameraSources() {
        return this.state.captureMode === "screen-mic-cam";
    }
    includesMicrophoneSource() {
        return this.state.captureMode === "screen-mic" || this.state.captureMode === "screen-mic-cam";
    }
    registerMicrophoneControls() {
        if (!this.set.microphoneStudio || !this.set.microphoneStudioToggle) return;
        if (!this.set.microphoneStudio.dataset.open) this.set.microphoneStudio.dataset.open = "false";
        this.set.microphoneStudioToggle.setAttribute("aria-expanded", "false");
        this.set.microphoneStudioToggle.disabled = true;
        this.set.microphoneStudioToggle.setAttribute("aria-disabled", "true");
        this.set.microphoneStudioPanel?.setAttribute("aria-hidden", "true");
        this.set.microphoneStudioToggle.addEventListener("click", this.handleMicrophoneToggle);
        if (this.set.microphoneList) this.set.microphoneList.addEventListener("change", this.handleMicrophoneSelectionChange);
        const audioInputs = this.streamManager.getAudioInputs();
        this.updateMicrophoneStudioAvailability(audioInputs);
    }
    handleMicrophoneToggle() {
        const isOpen = this.set.microphoneStudio?.dataset.open === "true";
        this.setMicrophoneStudioOpen(!isOpen);
    }
    updateMicrophoneStudioAvailability(input = []) {
        if (!this.set.microphoneStudio) return;
        let audioInputs = Array.isArray(input) ? input : [];
        const hasMicrophones = Array.isArray(input) ? input.length > 0 : Boolean(input);
        if (!Array.isArray(input) && hasMicrophones) audioInputs = this.streamManager.getAudioInputs();
        const shouldShow = hasMicrophones && this.includesMicrophoneSource();
        if (shouldShow) {
            this.set.microphoneStudio.classList.remove("hidden");
            this.set.microphoneStudio.removeAttribute("aria-hidden");
            if (this.set.microphoneStudioToggle) {
                this.set.microphoneStudioToggle.disabled = false;
                this.set.microphoneStudioToggle.setAttribute("aria-disabled", "false");
            }
            this.populateMicrophoneList(audioInputs);
            this.ensureDefaultMicrophoneSelection(audioInputs);
            this.syncMicrophoneSelection(audioInputs);
        } else {
            this.setMicrophoneStudioOpen(false);
            this.set.microphoneStudio.classList.add("hidden");
            this.set.microphoneStudio.setAttribute("aria-hidden", "true");
            if (this.set.microphoneStudioToggle) {
                this.set.microphoneStudioToggle.disabled = true;
                this.set.microphoneStudioToggle.setAttribute("aria-disabled", "true");
            }
            this.populateMicrophoneList([]);
            if (!this.includesMicrophoneSource()) this.resetMicrophoneSelection();
        }
    }
    setMicrophoneStudioOpen(isOpen) {
        if (!this.set.microphoneStudio) return;
        this.set.microphoneStudio.dataset.open = isOpen ? "true" : "false";
        this.set.microphoneStudioToggle?.setAttribute("aria-expanded", String(isOpen));
        this.set.microphoneStudioPanel?.setAttribute("aria-hidden", String(!isOpen));
    }
    registerPrimaryControls() {
        this.set.start?.addEventListener("click", ()=>{
            if (!this.state.isRecording) this.startRecording();
        });
        this.set.pauseAndResume?.addEventListener("click", ()=>{
            if (!this.state.isPause) this.pauseRecording();
            else this.resumeRecording();
        });
        this.set.stop?.addEventListener("click", ()=>{
            if (this.state.isRecording) this.stopRecording();
        });
        this.set.discardButton?.addEventListener("click", ()=>{
            this.discardRecording();
        });
        this.registerRecoveryControls();
    }
    updatePauseResumeLabel(text) {
        const label = this.set.pauseAndResume?.querySelector("span");
        if (label) label.textContent = text;
    }
    registerLayoutControls() {
        if (this.set.pipShapeControls) this.set.pipShapeControls.addEventListener("click", this.handlePipShapeClick);
        if (this.set.pipPositionControls) this.set.pipPositionControls.addEventListener("click", this.handlePipPositionClick);
        if (this.set.pipCornersToggle) this.set.pipCornersToggle.addEventListener("change", this.handlePipCornersToggle);
        if (this.set.cameraList) this.set.cameraList.addEventListener("change", this.handleCameraSelectionChange);
    }
    handlePipShapeClick(event) {
        const button = event.target.closest("button[data-shape]");
        if (!button) return;
        event.preventDefault();
        const { shape: shape } = button.dataset;
        this.layoutManager.setPipShape(shape);
        this.syncPipControls(this.layoutManager.getPipConfig());
    }
    handlePipPositionClick(event) {
        const button = event.target.closest("button[data-position]");
        if (!button) return;
        event.preventDefault();
        const { position: position } = button.dataset;
        this.layoutManager.setPipPosition(position);
        this.syncPipControls(this.layoutManager.getPipConfig());
    }
    handlePipCornersToggle(event) {
        const enabled = Boolean(event.target.checked);
        this.layoutManager.setPipRoundedCorners(enabled);
        this.syncPipControls(this.layoutManager.getPipConfig());
    }
    syncPipControls(config) {
        if (!config) return;
        if (this.set.pipShapeControls) this.set.pipShapeControls.querySelectorAll("button[data-shape]").forEach((btn)=>{
            const isActive = btn.dataset.shape === config.shape;
            btn.classList.toggle("active", isActive);
            btn.setAttribute("aria-pressed", String(isActive));
        });
        if (this.set.pipPositionControls) this.set.pipPositionControls.querySelectorAll("button[data-position]").forEach((btn)=>{
            const isActive = btn.dataset.position === config.position;
            btn.classList.toggle("active", isActive);
            btn.setAttribute("aria-pressed", String(isActive));
        });
        if (this.set.pipCornersToggle) {
            const shouldDisable = config.shape === "circle";
            this.set.pipCornersToggle.disabled = shouldDisable;
            this.set.pipCornersToggle.checked = Boolean(config.roundedCorners);
        }
        this.updatePipPreview(config);
        this.applyPipStylingToPreviews(config);
    }
    updatePipPreview(config) {
        if (!this.set.pipPreview || !config) return;
        const preview = this.set.pipPreview;
        const { shape: shape, position: position, roundedCorners: roundedCorners } = config;
        preview.classList.remove("is-rectangle", "is-square", "no-rounded", "position-top-left", "position-top-right", "position-bottom-left", "position-bottom-right");
        if (shape === "rectangle") preview.classList.add("is-rectangle");
        else if (shape === "square") preview.classList.add("is-square");
        if (!roundedCorners) preview.classList.add("no-rounded");
        switch(position){
            case "top-left":
                preview.classList.add("position-top-left");
                break;
            case "top-right":
                preview.classList.add("position-top-right");
                break;
            case "bottom-left":
                preview.classList.add("position-bottom-left");
                break;
            default:
                preview.classList.add("position-bottom-right");
                break;
        }
    }
    applyPipStylingToPreviews(config) {
        if (!config || !this.set.cameraPreviewGrid) return;
        const cards = this.set.cameraPreviewGrid.querySelectorAll(".sh__camera-preview-card");
        cards.forEach((card)=>{
            card.dataset.pipShape = config.shape;
            card.dataset.pipRounded = config.roundedCorners === false ? "flat" : "rounded";
        });
    }
    updatePrimaryCameraPreview() {
        if (!this.set.cameraPrimaryFrame) return;
        const container = this.set.cameraPrimaryFrame;
        const primaryId = this.state.primaryCameraId;
        const previewSource = primaryId ? this.cameraPreviewElements.get(primaryId) : null;
        if (!primaryId || !previewSource || !previewSource.srcObject && !previewSource.src) {
            if (this.primaryCameraPreview && container.contains(this.primaryCameraPreview)) {
                this.primaryCameraPreview.pause?.();
                this.primaryCameraPreview.srcObject = null;
                this.primaryCameraPreview.removeAttribute("src");
                this.primaryCameraPreview.load?.();
                container.removeChild(this.primaryCameraPreview);
            } else container.innerHTML = "";
            return;
        }
        if (!this.primaryCameraPreview) {
            const video = document.createElement("video");
            video.className = "sh__camera-primary-video";
            video.autoplay = true;
            video.muted = true;
            video.playsInline = true;
            this.primaryCameraPreview = video;
        }
        if (!container.contains(this.primaryCameraPreview)) {
            container.innerHTML = "";
            container.appendChild(this.primaryCameraPreview);
        }
        if (previewSource.srcObject && this.primaryCameraPreview.srcObject !== previewSource.srcObject) this.primaryCameraPreview.srcObject = previewSource.srcObject;
        else if (!previewSource.srcObject && previewSource.src && this.primaryCameraPreview.src !== previewSource.src) this.primaryCameraPreview.src = previewSource.src;
        this.primaryCameraPreview.play?.().catch(()=>{});
    }
    registerAutoSwitchControls() {
        if (this.set.autoSwitchToggle) this.set.autoSwitchToggle.addEventListener("change", this.handleAutoSwitchToggle);
        if (this.set.autoSwitchMin) this.set.autoSwitchMin.addEventListener("change", this.handleAutoSwitchMinChange);
        if (this.set.autoSwitchMax) this.set.autoSwitchMax.addEventListener("change", this.handleAutoSwitchMaxChange);
        if (this.set.autoSwitchDuration) this.set.autoSwitchDuration.addEventListener("change", this.handleAutoSwitchDurationChange);
    }
    toggleDropdown() {
        this.set.dropdownToggle.classList.toggle("toggled");
        this.set.dropdownChevron.classList.toggle("toggled");
        this.set.dropdownList.classList.toggle("open");
    }
    getSelectedValue(el) {
        const selectedAttrValue = el.getAttribute("data-value");
        if (selectedAttrValue) this.set.start.classList.add("visible");
        else this.set.start.classList.remove("visible");
        this.set.dropdownDefaultOption.textContent = el.innerText;
        // NOTE: mime type is now managed independently by registerFormatSelector()
        // and should NOT be overridden here.
        return selectedAttrValue;
    }
    handleCaptureModeChange() {
        const videoInputs = this.streamManager.getVideoInputs();
        const audioInputs = this.streamManager.getAudioInputs();
        const hasVideoInputs = videoInputs.length > 0;
        const hasAudioInputs = audioInputs.length > 0;
        if (this.includesCameraSources()) {
            this.updateCameraStudioAvailability(hasVideoInputs);
            if (!hasVideoInputs) this.clearSelectedCameras();
            else {
                this.ensureDefaultCameraSelection(videoInputs);
                this.syncCameraSelectionControls();
                this.prepareCameraPreviews().catch((error)=>{
                    console.warn("Impossibile preparare l'anteprima webcam", error);
                });
            }
        } else {
            if (this.state.selectedCameras.length) this.clearSelectedCameras();
            else this.clearCameraPreviews();
            this.updateCameraStudioAvailability(false);
        }
        if (this.includesMicrophoneSource()) {
            this.updateMicrophoneStudioAvailability(audioInputs);
            if (hasAudioInputs) this.ensureDefaultMicrophoneSelection(audioInputs);
        } else {
            this.updateMicrophoneStudioAvailability([]);
            this.resetMicrophoneSelection();
        }
        const cameraControlsEnabled = this.includesCameraSources();
        if (this.set.autoSwitchToggle) this.set.autoSwitchToggle.disabled = !cameraControlsEnabled;
        this.updateAutoSwitchUIState();
    }
    handleAutoSwitchToggle(event) {
        const enabled = event.target.checked;
        console.log("[AUTO-SWITCH] Toggle fired:", {
            enabled: enabled,
            selectedCameras: this.state.selectedCameras,
            primaryCameraId: this.state.primaryCameraId,
            currentAutoSwitchState: this.state.autoSwitchEnabled,
            includesCameraSources: this.includesCameraSources(),
            hasSecondaryCameras: this.hasSecondaryCameras()
        });
        if (enabled && this.state.selectedCameras.length <= 1) {
            console.warn("[AUTO-SWITCH] Not enough cameras, aborting");
            event.target.checked = false;
            this.state.autoSwitchEnabled = false;
            this.appendStatusNotification("error", "Seleziona almeno due webcam per usare il cambio automatico");
            return;
        }
        this.state.autoSwitchEnabled = enabled;
        console.log("[AUTO-SWITCH] State updated to:", this.state.autoSwitchEnabled);
        if (enabled) {
            console.log("[AUTO-SWITCH] Starting cycle");
            this.ensurePrimaryCamera();
            this.activatePrimaryCamera();
            this.startAutoSwitchTimer();
            if (this.state.isRecording) this.startAutoSwitchCountdown();
        } else {
            console.log("[AUTO-SWITCH] Stopping cycle");
            this.stopAutoSwitchTimer();
            this.activatePrimaryCamera();
            if (this.state.isRecording) this.stopAutoSwitchCountdown();
        }
        this.updateAutoSwitchUIState();
    }
    handleAutoSwitchMinChange(event) {
        const value = Math.max(1, Number(event.target.value) || $cb4d6b01942e8622$var$AUTO_SWITCH_MIN_DEFAULT);
        this.state.autoSwitchMinMinutes = value;
        if (this.state.autoSwitchMaxMinutes < value) {
            this.state.autoSwitchMaxMinutes = value;
            if (this.set.autoSwitchMax) this.set.autoSwitchMax.value = value;
        }
        this.restartAutoSwitchCycle({
            preserveActive: true
        });
    }
    handleAutoSwitchMaxChange(event) {
        const value = Math.max(1, Number(event.target.value) || $cb4d6b01942e8622$var$AUTO_SWITCH_MAX_DEFAULT);
        this.state.autoSwitchMaxMinutes = Math.max(value, this.state.autoSwitchMinMinutes);
        if (this.set.autoSwitchMax) this.set.autoSwitchMax.value = this.state.autoSwitchMaxMinutes;
        this.restartAutoSwitchCycle({
            preserveActive: true
        });
    }
    handleAutoSwitchDurationChange(event) {
        const value = Math.max(5, Number(event.target.value) || $cb4d6b01942e8622$var$AUTO_SWITCH_SPOTLIGHT_DEFAULT);
        this.state.autoSwitchSpotlightSeconds = value;
        this.restartAutoSwitchCycle({
            preserveActive: false
        });
    }
    handlePrimaryCameraHotkey() {
        if (!this.state.selectedCameras.length) return;
        this.ensurePrimaryCamera();
        this.activatePrimaryCamera();
        if (this.state.autoSwitchEnabled) this.restartAutoSwitchCycle({
            preserveActive: false
        });
    }
    handleAutoSwitchHotkey() {
        if (!this.set.autoSwitchToggle) return;
        if (this.set.autoSwitchToggle.disabled) {
            const message = this.includesCameraSources() ? "Seleziona due webcam per usare il cambio automatico" : "Passa alla modalit\xe0 con webcam per attivare il cambio automatico";
            this.appendStatusNotification("error", message);
            return;
        }
        const toggle = this.set.autoSwitchToggle;
        toggle.checked = !toggle.checked;
        toggle.dispatchEvent(new Event("change", {
            bubbles: true
        }));
    }
    async handleDevicesUpdate(devices) {
        const videoInputs = devices.filter((device)=>device.kind === "videoinput");
        const audioInputs = devices.filter((device)=>device.kind === "audioinput");
        const availableIds = videoInputs.map((device)=>device.deviceId);
        const removedSelections = this.state.selectedCameras.filter((id)=>!availableIds.includes(id));
        removedSelections.forEach((deviceId)=>{
            const preview = this.cameraPreviewElements.get(deviceId);
            if (preview) {
                preview.srcObject?.getTracks().forEach((track)=>track.stop());
                preview.remove();
                this.cameraPreviewElements.delete(deviceId);
            }
            this.streamManager.releaseCamera(deviceId);
        });
        this.state.selectedCameras = this.state.selectedCameras.filter((id)=>availableIds.includes(id));
        if (this.state.primaryCameraId && !availableIds.includes(this.state.primaryCameraId)) this.state.primaryCameraId = null;
        if (this.set.cameraList) {
            if (!videoInputs.length) {
                this.updateCameraStudioAvailability(false);
                this.set.cameraList.innerHTML = `<li class="sh__cam-list--empty">Nessuna webcam rilevata</li>`;
                this.clearCameraPreviews();
                this.stopAutoSwitchTimer();
            } else {
                this.updateCameraStudioAvailability(true);
                this.ensureDefaultCameraSelection(videoInputs);
                this.set.cameraList.innerHTML = videoInputs.map((device)=>`
              <li class="sh__cam-list--item">
                <label class="sh__device-card">
                  <input type="checkbox" value="${device.deviceId}" />
                  <span class="sh__device-card-indicator"></span>
                  <span class="sh__device-card-icon">\u{1F4F9}</span>
                  <span class="sh__device-card-info">
                    <span class="sh__device-card-title">${device.label || "Webcam"}</span>
                    <span class="sh__device-card-subtitle">Dispositivo video</span>
                  </span>
                </label>
              </li>
            `).join("");
                this.state.selectedCameras.forEach((deviceId)=>{
                    const checkbox = this.set.cameraList.querySelector(`input[type="checkbox"][value="${deviceId}"]`);
                    if (checkbox) checkbox.checked = true;
                });
                if (this.state.selectedCameras.length) {
                    await this.prepareCameraPreviews();
                    if (this.state.autoSwitchEnabled) this.startAutoSwitchTimer();
                } else this.renderCameraPreviewGrid();
            }
        }
        const audioIds = audioInputs.map((device)=>device.deviceId);
        if (this.state.selectedMicrophone && !audioIds.includes(this.state.selectedMicrophone)) this.state.selectedMicrophone = null;
        this.updateMicrophoneStudioAvailability(audioInputs);
        if (audioInputs.length) this.ensureDefaultMicrophoneSelection(audioInputs);
        this.ensurePrimaryCamera();
        this.updateAutoSwitchUIState();
    }
    ensureDefaultCameraSelection(videoInputs = []) {
        if (!this.includesCameraSources()) return;
        const available = videoInputs.length ? videoInputs : this.streamManager.getVideoInputs();
        if (!available.length) return;
        const availableIds = available.map((device)=>device.deviceId);
        const validSelected = this.state.selectedCameras.filter((id)=>availableIds.includes(id));
        if (validSelected.length > 0) {
            this.state.selectedCameras = validSelected;
            if (!this.state.primaryCameraId || !validSelected.includes(this.state.primaryCameraId)) this.state.primaryCameraId = validSelected[0];
        } else {
            const firstCamera = available[0];
            this.state.selectedCameras = [
                firstCamera.deviceId
            ];
            this.state.primaryCameraId = firstCamera.deviceId;
            this.layoutManager.setActiveCameraIndex(0);
        }
    }
    syncCameraSelectionControls() {
        if (!this.set.cameraList) return;
        this.set.cameraList.querySelectorAll('input[type="checkbox"]').forEach((checkbox)=>{
            checkbox.checked = this.state.selectedCameras.includes(checkbox.value);
        });
    }
    async handleCameraSelectionChange(event) {
        if (!event.target.matches('input[type="checkbox"]')) return;
        const checkboxes = [
            ...this.set.cameraList.querySelectorAll('input[type="checkbox"]')
        ];
        const selected = [];
        checkboxes.forEach((box)=>{
            if (box.checked) {
                if (selected.length < $cb4d6b01942e8622$var$CAMERA_LIMIT) selected.push(box.value);
                else box.checked = false;
            }
        });
        if (this.includesCameraSources() && selected.length === 0) {
            event.target.checked = true;
            this.appendStatusNotification("error", "Almeno una webcam deve rimanere selezionata");
            return;
        }
        const removed = this.state.selectedCameras.filter((id)=>!selected.includes(id));
        removed.forEach((deviceId)=>{
            const preview = this.cameraPreviewElements.get(deviceId);
            if (preview) {
                preview.srcObject?.getTracks().forEach((track)=>track.stop());
                preview.remove();
                this.cameraPreviewElements.delete(deviceId);
            }
            this.streamManager.releaseCamera(deviceId);
        });
        this.state.selectedCameras = selected;
        const activeIndex = this.layoutManager.getActiveCameraIndex();
        if (activeIndex >= this.state.selectedCameras.length) this.layoutManager.setActiveCameraIndex(Math.max(0, this.state.selectedCameras.length - 1));
        if (!this.state.selectedCameras.length) {
            this.stopAutoSwitchTimer();
            this.renderCameraPreviewGrid();
            this.setCameraStudioOpen(false);
            this.ensurePrimaryCamera();
            this.updateAutoSwitchUIState();
            return;
        }
        await this.prepareCameraPreviews();
        this.setCameraStudioOpen(true);
        this.ensurePrimaryCamera();
        this.updateAutoSwitchUIState();
        if (this.state.autoSwitchEnabled) this.startAutoSwitchTimer();
    }
    handleMicrophoneSelectionChange(event) {
        if (!event.target.matches('input[type="radio"]')) return;
        if (this.includesMicrophoneSource() && !event.target.value) {
            if (this.state.selectedMicrophone) {
                const radio = this.set.microphoneList?.querySelector(`input[type="radio"][value="${this.state.selectedMicrophone}"]`);
                if (radio) radio.checked = true;
            }
            this.appendStatusNotification("error", "Almeno un microfono deve rimanere selezionato");
            return;
        }
        this.state.selectedMicrophone = event.target.value || null;
    }
    async prepareCameraPreviews() {
        if (!this.set.cameraPreviewGrid) return;
        const streams = await Promise.all(this.state.selectedCameras.map((deviceId)=>this.streamManager.getCameraStream(deviceId).catch((error)=>{
                console.error("Camera stream error", error);
                return null;
            })));
        this.state.selectedCameras.forEach((deviceId, index)=>{
            const stream = streams[index];
            if (!stream) return;
            let preview = this.cameraPreviewElements.get(deviceId);
            if (!preview) {
                preview = document.createElement("video");
                preview.className = "sh__camera-preview";
                preview.muted = true;
                preview.autoplay = true;
                preview.playsInline = true;
                this.cameraPreviewElements.set(deviceId, preview);
            }
            preview.srcObject = stream;
        });
        this.renderCameraPreviewGrid();
    }
    renderCameraPreviewGrid() {
        if (!this.set.cameraPreviewGrid) return;
        if (this.state.selectedCameras.length <= 1) {
            this.set.cameraPreviewGrid.innerHTML = "";
            this.set.cameraPreviewGrid.style.display = "none";
            this.updatePrimaryCameraPreview();
            return;
        }
        this.set.cameraPreviewGrid.style.display = "";
        this.set.cameraPreviewGrid.innerHTML = "";
        this.state.selectedCameras.forEach((deviceId, index)=>{
            const video = this.cameraPreviewElements.get(deviceId);
            if (!video) return;
            const wrapper = document.createElement("div");
            wrapper.className = "sh__camera-preview-card";
            wrapper.dataset.camera = deviceId;
            const pipConfig = this.layoutManager.getPipConfig?.() || {};
            wrapper.dataset.pipShape = pipConfig.shape || "circle";
            wrapper.dataset.pipRounded = pipConfig.roundedCorners === false ? "flat" : "rounded";
            const isActive = index === this.layoutManager.getActiveCameraIndex();
            const isPrimary = deviceId === this.state.primaryCameraId;
            const badgeClasses = [
                "sh__camera-preview__badge"
            ];
            if (isActive) badgeClasses.push("active");
            else if (isPrimary) badgeClasses.push("primary");
            const badgeLabel = isActive ? "Attiva" : isPrimary ? "Primaria" : "Anteprima";
            wrapper.classList.toggle("is-active", isActive);
            wrapper.classList.toggle("is-primary", isPrimary);
            wrapper.innerHTML = `
        <div class="${badgeClasses.join(" ")}">
          ${badgeLabel}
        </div>
      `;
            wrapper.appendChild(video);
            wrapper.addEventListener("click", ()=>{
                const clickedIndex = this.state.selectedCameras.indexOf(deviceId);
                if (clickedIndex >= 0) {
                    this.state.primaryCameraId = deviceId;
                    this.state.autoSwitchLastSecondary = null;
                    this.layoutManager.setActiveCameraIndex(clickedIndex);
                    this.renderCameraPreviewGrid();
                    if (this.state.autoSwitchEnabled) this.restartAutoSwitchCycle({
                        preserveActive: false
                    });
                }
            });
            this.set.cameraPreviewGrid.appendChild(wrapper);
        });
        this.updatePrimaryCameraPreview();
    }
    async startRecording() {
        if (!this.state.captureMode) {
            this.appendStatusNotification("error", "Scegli cosa registrare prima di iniziare");
            console.warn("Nessuna modalit\xe0 di registrazione selezionata");
            return;
        }
        if (this.includesMicrophoneSource() && !this.state.selectedMicrophone) {
            this.appendStatusNotification("error", "Seleziona un microfono prima di iniziare la registrazione");
            return;
        }
        if (this.includesCameraSources() && this.state.selectedCameras.length === 0) {
            this.appendStatusNotification("error", "Seleziona una videocamera prima di iniziare la registrazione");
            return;
        }
        const layout = this.layoutManager.getActiveLayout();
        const requiredCameras = layout?.requires?.cameras ?? 0;
        if (this.includesCameraSources() && requiredCameras > 0) {
            if (this.state.selectedCameras.length < requiredCameras) {
                this.appendStatusNotification("error", `Seleziona almeno ${requiredCameras} webcam per questo layout`);
                console.warn("Layout requires more webcam sources");
                return;
            }
        }
        try {
            this.state.filename = document.getElementById("filename")?.value || "";
            this.state.isRecording = true;
            this.state.isPause = false;
            this.recordedChunks = [];
            if (this.lastRecordingUrl) {
                URL.revokeObjectURL(this.lastRecordingUrl);
                this.lastRecordingUrl = null;
            }
            this.enableWakeLockHandling();
            this.currentSessionId = null;
            this.chunkIndex = 0;
            this.storageFailed = false;
            this.pendingChunkWrites = [];
            this.currentSessionId = await (0, $920a45577759f24a$export$638493c32a77e76d).startNewSession(this.state.mime, this.state.filename);
            this.storageFailed = !this.currentSessionId;
            // Register beforeunload event listener to prevent tab closure
            window.addEventListener("beforeunload", this.beforeUnloadHandler);
            const { composedStream: composedStream, previewStream: previewStream } = await this.prepareRecordingStreams();
            this.setupMediaRecorder(composedStream);
            if (this.set.preview) {
                if (this.set.preview.src && this.set.preview.src.startsWith("blob:")) URL.revokeObjectURL(this.set.preview.src);
                this.set.preview.removeAttribute("src");
                this.set.preview.srcObject = previewStream;
                this.set.preview.controls = false;
                this.set.preview.muted = true;
                this.set.preview.classList.add("visible");
            }
            // Hide all UI elements except video and recording controls
            this.set.logo?.classList.add("force-hidden");
            this.set.headerText?.classList.add("force-hidden");
            this.set.choice?.classList.add("force-hidden");
            this.set.mimeChoiceWrapper?.classList.add("force-hidden");
            this.set.mimeChoiceWrapper?.classList.remove("visible");
            this.set.microphoneStudio?.classList.add("hidden", "force-hidden");
            this.set.cameraStudio?.classList.add("hidden", "force-hidden");
            this.set.start?.classList.add("force-hidden");
            this.set.footer?.classList.add("force-hidden");
            // Show recording info and controls
            this.set.recordingInfo?.classList.add("visible");
            this.set.recordingControls?.classList.add("visible");
            this.set.pauseAndResume?.classList.add("visible");
            this.set.stop?.classList.add("visible");
            // Hide review controls
            if (this.set.reviewControls) {
                this.set.reviewControls.classList.remove("visible");
                this.set.reviewControls.setAttribute("aria-hidden", "true");
                this.set.reviewControls.style.setProperty("display", "none");
            }
            if (this.set.download) {
                if (this.set.download.href && this.set.download.href.startsWith("blob:")) URL.revokeObjectURL(this.set.download.href);
                this.set.download.href = "";
                this.set.download.removeAttribute("download");
                this.set.download.classList.remove("visible");
                this.set.download.setAttribute("disabled", "true");
            }
            if (this.set.discardButton) {
                this.set.discardButton.setAttribute("disabled", "true");
                this.set.discardButton.classList.remove("visible");
            }
            this.set.pauseAndResume?.classList.add("pause");
            this.set.pauseAndResume?.classList.remove("resume");
            this.updatePauseResumeLabel("Pausa");
            // Start recording timer
            this.startRecordingTimer();
            // Start auto-switch countdown if enabled
            if (this.state.autoSwitchEnabled) this.startAutoSwitchCountdown();
            else {
                this.set.recordingSwitch?.style.setProperty("display", "none");
                this.refreshAutoSwitchCountdownDisplay();
            }
            this.appendStatusNotification("start");
        } catch (error) {
            console.error("Failed to start recording", error);
            alert("Errore avvio registrazione:\n" + error.message + "\n\nStack:\n" + error.stack);
            this.appendStatusNotification("error", "Impossibile avviare la registrazione: " + error.message);
            this.state.isRecording = false;
            this.disableWakeLockHandling();
            window.removeEventListener("beforeunload", this.beforeUnloadHandler);
        }
    }
    async prepareRecordingStreams() {
        const needsMicrophone = this.includesMicrophoneSource();
        const captureSystemAudio = true;
        const screenStream = await this.streamManager.getScreenStream({
            audio: captureSystemAudio
        });
        let microphoneStream = null;
        if (needsMicrophone) try {
            microphoneStream = await this.streamManager.getMicrophoneStream({
                deviceId: this.state.selectedMicrophone
            });
        } catch (error) {
            console.error("Unable to access microphone", error);
            this.appendStatusNotification("error", "Impossibile accedere al microfono selezionato");
            microphoneStream = null;
        }
        const cameraStreams = await Promise.all(this.state.selectedCameras.map((deviceId)=>this.streamManager.getCameraStream(deviceId).catch((error)=>{
                console.error("Unable to start camera", error);
                return null;
            })));
        const filteredCameraStreams = cameraStreams.filter(Boolean);
        this.mixEngine.setScreenStream(screenStream);
        this.mixEngine.setCameraStreams(filteredCameraStreams);
        const previewStream = this.mixEngine.start({
            frameRate: 30
        });
        const audioTracks = [];
        if (screenStream?.getAudioTracks().length) audioTracks.push(...screenStream.getAudioTracks());
        if (microphoneStream?.getAudioTracks().length) audioTracks.push(...microphoneStream.getAudioTracks());
        const audioMixStream = await this.mixAudioTracks(audioTracks);
        const composedStream = new MediaStream([
            ...previewStream.getVideoTracks(),
            ...audioMixStream ? audioMixStream.getAudioTracks() : []
        ]);
        this.activeStreams = {
            screenStream: screenStream,
            microphoneStream: microphoneStream,
            cameraStreams: filteredCameraStreams,
            previewStream: previewStream,
            audioMixStream: audioMixStream
        };
        if (this.state.autoSwitchEnabled) this.startAutoSwitchTimer();
        return {
            composedStream: composedStream,
            previewStream: previewStream
        };
    }
    supportsWakeLock() {
        return typeof navigator !== "undefined" && !!navigator.wakeLock && typeof navigator.wakeLock.request === "function";
    }
    enableWakeLockHandling() {
        if (!this.supportsWakeLock()) return;
        if (!this.wakeLockVisibilityListenerAttached && typeof document !== "undefined") {
            document.addEventListener("visibilitychange", this.handleWakeLockVisibilityChange);
            this.wakeLockVisibilityListenerAttached = true;
        }
        this.clearWakeLockRetry();
        this.acquireWakeLock();
    }
    disableWakeLockHandling() {
        this.clearWakeLockRetry();
        this.releaseWakeLock();
        if (this.wakeLockVisibilityListenerAttached && typeof document !== "undefined") {
            document.removeEventListener("visibilitychange", this.handleWakeLockVisibilityChange);
            this.wakeLockVisibilityListenerAttached = false;
        }
    }
    async acquireWakeLock() {
        if (!this.supportsWakeLock()) return;
        if (!this.state.isRecording) return;
        if (this.wakeLockSentinel) return;
        if (!this.isDocumentVisible()) return;
        try {
            this.wakeLockSentinel = await navigator.wakeLock.request("screen");
            this.wakeLockSentinel.addEventListener("release", this.handleWakeLockRelease);
        } catch (error) {
            const hiddenForPolicy = !this.isDocumentVisible();
            if (!hiddenForPolicy) {
                console.warn("Unable to acquire wake lock", error);
                this.scheduleWakeLockRetry();
            }
        }
    }
    async releaseWakeLock() {
        if (!this.wakeLockSentinel) return;
        try {
            this.wakeLockSentinel.removeEventListener("release", this.handleWakeLockRelease);
            await this.wakeLockSentinel.release();
        } catch (error) {
            console.debug("Wake lock release failed", error);
        } finally{
            this.wakeLockSentinel = null;
        }
    }
    handleWakeLockRelease() {
        if (!this.wakeLockSentinel) return;
        this.wakeLockSentinel.removeEventListener("release", this.handleWakeLockRelease);
        this.wakeLockSentinel = null;
        if (this.state.isRecording && this.isDocumentVisible()) this.scheduleWakeLockRetry();
    }
    handleWakeLockVisibilityChange() {
        if (!this.state.isRecording) return;
        if (this.isDocumentVisible()) this.acquireWakeLock();
    }
    scheduleWakeLockRetry(delay = 1500) {
        if (!this.state.isRecording) return;
        if (this.wakeLockRetryTimeout) return;
        if (!this.isDocumentVisible()) return;
        this.wakeLockRetryTimeout = setTimeout(()=>{
            this.wakeLockRetryTimeout = null;
            if (this.state.isRecording && this.isDocumentVisible()) this.acquireWakeLock();
        }, delay);
    }
    clearWakeLockRetry() {
        if (this.wakeLockRetryTimeout) {
            clearTimeout(this.wakeLockRetryTimeout);
            this.wakeLockRetryTimeout = null;
        }
    }
    isDocumentVisible() {
        if (typeof document === "undefined") return true;
        return document.visibilityState === "visible";
    }
    async mixAudioTracks(tracks = []) {
        const validTracks = tracks.filter((track)=>Boolean(track));
        if (!validTracks.length) return null;
        const AudioCtx = window.AudioContext || window.webkitAudioContext;
        const useFallbackMix = !AudioCtx;
        if (useFallbackMix) {
            const fallbackStream = new MediaStream();
            validTracks.forEach((track)=>fallbackStream.addTrack(track));
            return fallbackStream;
        }
        try {
            if (!this.audioContext || this.audioContext.state === "closed") this.audioContext = new AudioCtx();
            if (this.audioSources.length) {
                this.audioSources.forEach(({ source: source })=>{
                    try {
                        source.disconnect();
                    } catch (error) {
                        console.debug("Audio source disconnect failed", error);
                    }
                });
                this.audioSources = [];
            }
            this.mixedAudioDestination = this.audioContext.createMediaStreamDestination();
            validTracks.forEach((track)=>{
                const stream = new MediaStream([
                    track
                ]);
                const source = this.audioContext.createMediaStreamSource(stream);
                source.connect(this.mixedAudioDestination);
                this.audioSources.push({
                    source: source,
                    stream: stream
                });
            });
            if (this.audioContext.state === "suspended") await this.audioContext.resume().catch(()=>{});
            this.audioContext.onstatechange = ()=>{
                if (this.audioContext && this.audioContext.state === "suspended" && this.state.isRecording && !this.state.isPause) this.audioContext.resume().catch(()=>{});
            };
            return this.mixedAudioDestination.stream;
        } catch (error) {
            console.warn("Falling back to direct audio mix", error);
            const fallbackStream = new MediaStream();
            validTracks.forEach((track)=>fallbackStream.addTrack(track));
            return fallbackStream;
        }
    }
    setupMediaRecorder(stream) {
        const mimeType = `video/${this.state.mime}`;
        const options = MediaRecorder.isTypeSupported(mimeType) ? {
            mimeType: mimeType,
            videoBitsPerSecond: 3500000
        } : {
            videoBitsPerSecond: 3500000
        };
        this.set.mediaRecorder = new MediaRecorder(stream, options);
        this.set.mediaRecorder.ondataavailable = async (event)=>{
            if (!event.data?.size) return;
            if (this.currentSessionId && !this.storageFailed) {
                const chunkIndex = this.chunkIndex;
                this.chunkIndex += 1;
                const writePromise = (0, $920a45577759f24a$export$638493c32a77e76d).appendChunk(this.currentSessionId, chunkIndex, event.data).catch((error)=>{
                    console.warn("IndexedDB chunk write failed; falling back to memory", error);
                    this.storageFailed = true;
                    this.recordedChunks.push(event.data);
                });
                this.pendingChunkWrites.push(writePromise);
                try {
                    await writePromise;
                    return;
                } catch (error) {
                    console.debug("Chunk write recovery handled", error);
                }
            }
            this.recordedChunks.push(event.data);
        };
        this.set.mediaRecorder.onstop = async ()=>{
            await this.bakeVideo();
        };
        this.set.mediaRecorder.start(2000);
    }
    pauseRecording() {
        if (!this.set.mediaRecorder || this.state.isPause) return;
        this.set.mediaRecorder.pause();
        this.state.isPause = true;
        this.appendStatusNotification("pause");
        this.set.pauseAndResume?.classList.add("resume");
        this.set.pauseAndResume?.classList.remove("pause");
        this.updatePauseResumeLabel("Riprendi");
        const currentTimerVal = this.set.recordingTimer?.textContent || "00:00:00";
        document.title = `\u{23F8}\u{FE0F} PAUSE [${currentTimerVal}] - ScreenREC`;
    }
    resumeRecording() {
        if (!this.set.mediaRecorder || !this.state.isPause) return;
        this.set.mediaRecorder.resume();
        this.state.isPause = false;
        this.appendStatusNotification("resume");
        this.set.pauseAndResume?.classList.remove("resume");
        this.set.pauseAndResume?.classList.add("pause");
        this.updatePauseResumeLabel("Pausa");
        const currentTimerVal = this.set.recordingTimer?.textContent || "00:00:00";
        document.title = `\u{1F534} REC [${currentTimerVal}] - ScreenREC`;
    }
    stopRecording() {
        this.stopAutoSwitchTimer();
        this.stopRecordingTimer();
        this.stopAutoSwitchCountdown();
        this.state.isRecording = false;
        this.disableWakeLockHandling();
        window.removeEventListener("beforeunload", this.beforeUnloadHandler);
        if (this.set.mediaRecorder && this.set.mediaRecorder.state !== "inactive") this.set.mediaRecorder.stop();
        this.mixEngine.stop();
        this.mixEngine.dispose();
        this.streamManager.stopAll();
        this.cleanupAudio();
        if (this.set.preview) {
            this.set.preview.srcObject = null;
            this.set.preview.controls = false;
            this.set.preview.muted = true;
            this.set.preview.classList.add("visible");
        }
        // Hide recording info and controls
        this.set.recordingInfo?.classList.remove("visible");
        this.set.recordingControls?.classList.remove("visible");
        this.set.pauseAndResume?.classList.remove("visible");
        this.set.pauseAndResume?.classList.remove("resume");
        this.set.stop?.classList.remove("visible");
        this.set.recordingSwitch?.style.setProperty("display", "none");
        this.updatePauseResumeLabel("Pausa");
        // Hide configuration UI while reviewing
        this.set.logo?.classList.add("force-hidden");
        this.set.headerText?.classList.add("force-hidden");
        this.set.choice?.classList.add("force-hidden");
        this.set.mimeChoiceWrapper?.classList.add("force-hidden");
        this.set.mimeChoiceWrapper?.classList.remove("visible");
        this.set.microphoneStudio?.classList.add("hidden", "force-hidden");
        this.set.cameraStudio?.classList.add("hidden", "force-hidden");
        this.set.start?.classList.add("force-hidden");
        this.set.footer?.classList.add("force-hidden");
        // Show only video and review controls (save + discard)
        if (this.set.reviewControls) {
            this.set.reviewControls.classList.add("visible");
            this.set.reviewControls.classList.remove("force-hidden");
            this.set.reviewControls.style.removeProperty("display");
            this.set.reviewControls.setAttribute("aria-hidden", "false");
        }
        if (this.set.discardButton) {
            this.set.discardButton.removeAttribute("disabled");
            this.set.discardButton.classList.add("visible");
        }
        if (this.set.download) {
            this.set.download.classList.add("visible");
            this.set.download.setAttribute("disabled", "true");
        }
        this.appendStatusNotification("stop");
        if (this.state.selectedCameras.length) this.prepareCameraPreviews().catch((error)=>{
            console.warn("Impossibile ripristinare le anteprime camera", error);
        });
    }
    startRecordingTimer() {
        this.recordingStartTime = Date.now();
        this.originalTitle = document.title || "ScreenREC - A simple web screen recorder";
        if (this.set.recordingTimer) this.set.recordingTimer.textContent = "00:00:00";
        this.recordingTimerInterval = setInterval(()=>{
            if (!this.state.isRecording || this.state.isPause) return;
            const elapsed = Math.floor((Date.now() - this.recordingStartTime) / 1000);
            const hours = Math.floor(elapsed / 3600);
            const minutes = Math.floor(elapsed % 3600 / 60);
            const seconds = elapsed % 60;
            const timeString = [
                hours,
                minutes,
                seconds
            ].map((n)=>String(n).padStart(2, "0")).join(":");
            if (this.set.recordingTimer) this.set.recordingTimer.textContent = timeString;
            document.title = `\u{1F534} REC [${timeString}] - ScreenREC`;
        }, 1000);
    }
    stopRecordingTimer() {
        if (this.recordingTimerInterval) {
            clearInterval(this.recordingTimerInterval);
            this.recordingTimerInterval = null;
        }
        this.recordingStartTime = null;
        if (this.originalTitle) document.title = this.originalTitle;
    }
    startAutoSwitchCountdown() {
        this.stopAutoSwitchCountdown();
        if (!this.state.autoSwitchEnabled || !this.set.recordingSwitch) return;
        this.set.recordingSwitch.style.removeProperty("display");
        this.refreshAutoSwitchCountdownDisplay();
        this.autoSwitchCountdownInterval = setInterval(()=>{
            if (!this.state.isRecording) return;
            if (this.state.isPause) return;
            this.refreshAutoSwitchCountdownDisplay();
        }, 500);
    }
    stopAutoSwitchCountdown() {
        if (this.autoSwitchCountdownInterval) {
            clearInterval(this.autoSwitchCountdownInterval);
            this.autoSwitchCountdownInterval = null;
        }
        if (this.set.recordingSwitch) this.set.recordingSwitch.style.setProperty("display", "none");
        if (this.set.recordingSwitchValue) this.set.recordingSwitchValue.textContent = "--:--";
    }
    getAutoSwitchRemainingMs() {
        if (this.state.autoSwitchMode === "spotlight" && this.state.autoSwitchSpotlightEndsAt) return Math.max(0, this.state.autoSwitchSpotlightEndsAt - Date.now());
        if (this.state.autoSwitchTimerEndsAt) return Math.max(0, this.state.autoSwitchTimerEndsAt - Date.now());
        return null;
    }
    refreshAutoSwitchCountdownDisplay() {
        if (!this.set.recordingSwitchValue) return;
        const remainingMs = this.getAutoSwitchRemainingMs();
        if (remainingMs === null || Number.isNaN(remainingMs)) {
            this.set.recordingSwitchValue.textContent = "--:--";
            return;
        }
        const totalSeconds = Math.max(0, Math.ceil(remainingMs / 1000));
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        this.set.recordingSwitchValue.textContent = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
    }
    async bakeVideo() {
        if (this.pendingChunkWrites.length) {
            await Promise.allSettled(this.pendingChunkWrites);
            this.pendingChunkWrites = [];
        }
        let chunks = this.recordedChunks;
        if (this.currentSessionId) {
            const storedChunks = await (0, $920a45577759f24a$export$638493c32a77e76d).getSessionChunks(this.currentSessionId);
            chunks = [
                ...storedChunks,
                ...this.recordedChunks
            ];
            await (0, $920a45577759f24a$export$638493c32a77e76d).markSessionCompleted(this.currentSessionId);
        }
        if (!chunks.length) {
            this.appendStatusNotification("error", "Registrazione non valida");
            return;
        }
        const blob = new Blob(chunks, {
            type: `video/${this.state.mime}`
        });
        const savedName = this.state.filename || this.getRandomString(15);
        const url = URL.createObjectURL(blob);
        this.lastRecordingUrl = url;
        if (this.set.download) {
            this.set.download.href = url;
            this.set.download.download = `${savedName}.${this.state.mime}`;
            this.set.download.classList.add("visible");
            this.set.download.removeAttribute("disabled");
        }
        if (this.set.preview) {
            this.set.preview.autoplay = false;
            this.set.preview.srcObject = null;
            this.set.preview.src = url;
            this.set.preview.controls = true;
            this.set.preview.muted = false;
            this.set.preview.classList.add("visible");
        }
        if (this.set.reviewControls) {
            this.set.reviewControls.classList.add("visible");
            this.set.reviewControls.style.removeProperty("display");
            this.set.reviewControls.setAttribute("aria-hidden", "false");
        }
        if (this.set.discardButton) {
            this.set.discardButton.removeAttribute("disabled");
            this.set.discardButton.classList.add("visible");
        }
    }
    discardRecording() {
        // Clear recorded data
        this.recordedChunks = [];
        if (this.lastRecordingUrl) {
            URL.revokeObjectURL(this.lastRecordingUrl);
            this.lastRecordingUrl = null;
        }
        // Clear video preview
        if (this.set.preview) {
            if (this.set.preview.src && this.set.preview.src.startsWith("blob:")) URL.revokeObjectURL(this.set.preview.src);
            this.set.preview.removeAttribute("src");
            this.set.preview.srcObject = null;
            this.set.preview.controls = false;
            this.set.preview.muted = true;
            this.set.preview.autoplay = true;
            this.set.preview.classList.remove("visible");
        }
        if (this.set.download) {
            if (this.set.download.href && this.set.download.href.startsWith("blob:")) URL.revokeObjectURL(this.set.download.href);
            this.set.download.href = "";
            this.set.download.removeAttribute("download");
            this.set.download.classList.remove("visible");
            this.set.download.setAttribute("disabled", "true");
        }
        if (this.set.discardButton) {
            this.set.discardButton.setAttribute("disabled", "true");
            this.set.discardButton.classList.remove("visible");
        }
        // Hide review controls
        if (this.set.reviewControls) {
            this.set.reviewControls.classList.remove("visible");
            this.set.reviewControls.setAttribute("aria-hidden", "true");
            this.set.reviewControls.style.setProperty("display", "none");
        }
        // Show all config UI elements again
        this.set.logo?.classList.remove("force-hidden");
        this.set.headerText?.classList.remove("force-hidden");
        this.set.choice?.classList.remove("force-hidden");
        // Restore format selector visibility (captureMode is already chosen)
        this.set.mimeChoiceWrapper?.classList.remove("force-hidden");
        this.set.mimeChoiceWrapper?.classList.add("visible");
        this.set.footer?.classList.remove("force-hidden");
        // Show studios and start button only if filename is present
        const filenameInput = document.getElementById("filename");
        const hasFilename = filenameInput?.value.trim().length > 0;
        if (hasFilename) {
            this.set.microphoneStudio?.classList.remove("hidden", "force-hidden");
            this.set.cameraStudio?.classList.remove("hidden", "force-hidden");
            this.set.start?.classList.remove("force-hidden");
        }
        // Restore camera previews if needed
        if (this.state.selectedCameras.length) this.prepareCameraPreviews().catch((error)=>{
            console.warn("Impossibile ripristinare le anteprime camera", error);
        });
        this.appendStatusNotification("info", "Registrazione scartata");
    }
    cleanupAudio() {
        if (this.audioSources?.length) {
            this.audioSources.forEach(({ source: source })=>{
                try {
                    source.disconnect();
                } catch (error) {
                    console.debug("Audio source disconnect during cleanup failed", error);
                }
            });
            this.audioSources = [];
        }
        if (this.audioContext) {
            this.audioContext.close().catch(()=>{});
            this.audioContext = null;
        }
        this.mixedAudioDestination = null;
    }
    getRandomString(length) {
        const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        return Array.from({
            length: length
        }, ()=>chars[Math.floor(Math.random() * chars.length)]).join("");
    }
    appendStatusNotification(actionType, customMessage = "") {
        if (this.toastTimeout) clearTimeout(this.toastTimeout);
        const notificationText = actionType === "start" ? "Registrazione avviata" : actionType === "stop" ? "Registrazione terminata" : actionType === "pause" ? "Registrazione in pausa" : actionType === "resume" ? "Registrazione ripresa" : actionType === "error" ? customMessage || "Errore nella registrazione" : "";
        this.set.toast.className = "";
        this.set.toast.classList.add(actionType === "stop" ? "success" : actionType === "pause" ? "warning" : actionType === "error" ? "error" : "active");
        document.getElementById("desc").innerHTML = notificationText || customMessage;
        const closeBtn = this.set.toast.querySelector(".toast-close");
        if (closeBtn) closeBtn.onclick = ()=>{
            this.set.toast.classList.add("closing");
            setTimeout(()=>this.set.toast.classList.remove("active", "closing"), 500);
        };
        this.toastTimeout = setTimeout(()=>{
            this.set.toast.classList.remove("active");
        }, 3500);
    }
    cycleActiveCamera() {
        if (!this.state.selectedCameras.length) return;
        this.layoutManager.cycleCamera(this.state.selectedCameras.length);
        this.renderCameraPreviewGrid();
        if (this.state.autoSwitchEnabled) this.restartAutoSwitchCycle({
            preserveActive: true
        });
    }
    startAutoSwitchTimer({ preserveActive: preserveActive = false } = {}) {
        this.restartAutoSwitchCycle({
            preserveActive: preserveActive
        });
    }
    restartAutoSwitchCycle({ preserveActive: preserveActive = false } = {}) {
        const wasSpotlight = this.state.autoSwitchMode === "spotlight";
        const currentSecondary = this.state.autoSwitchCurrentSecondary;
        this.stopAutoSwitchTimer({
            resetState: !preserveActive
        });
        if (!this.state.autoSwitchEnabled || !this.hasSecondaryCameras()) return;
        this.ensurePrimaryCamera();
        if (preserveActive && wasSpotlight && currentSecondary) {
            this.state.autoSwitchMode = "spotlight";
            this.state.autoSwitchCurrentSecondary = currentSecondary;
            this.startSpotlightCountdown();
            return;
        }
        if (!preserveActive) {
            this.clearSpotlightState();
            this.activatePrimaryCamera();
        }
        this.scheduleNextAutoSwitch();
    }
    scheduleNextAutoSwitch() {
        this.clearAutoSwitchTimer();
        if (!this.state.autoSwitchEnabled || !this.hasSecondaryCameras()) return;
        const delay = this.getRandomAutoSwitchDelayMs();
        this.state.autoSwitchMode = "waiting";
        this.state.autoSwitchTimerEndsAt = Date.now() + delay;
        this.state.autoSwitchTimer = setTimeout(()=>{
            this.state.autoSwitchTimer = null;
            this.state.autoSwitchTimerEndsAt = null;
            this.beginAutoSwitchSpotlight();
        }, delay);
        this.refreshAutoSwitchCountdownDisplay();
    }
    beginAutoSwitchSpotlight() {
        if (!this.state.autoSwitchEnabled || !this.hasSecondaryCameras()) {
            this.clearSpotlightState();
            return;
        }
        const nextSecondary = this.pickNextSecondaryCamera();
        if (!nextSecondary) {
            this.scheduleNextAutoSwitch();
            return;
        }
        if (!this.enterSpotlightFor(nextSecondary)) this.scheduleNextAutoSwitch();
    }
    enterSpotlightFor(deviceId) {
        const index = this.state.selectedCameras.indexOf(deviceId);
        if (index === -1) return false;
        this.state.autoSwitchCurrentSecondary = deviceId;
        this.state.autoSwitchMode = "spotlight";
        this.layoutManager.setActiveCameraIndex(index);
        this.renderCameraPreviewGrid();
        this.startSpotlightCountdown();
        return true;
    }
    startSpotlightCountdown() {
        this.clearSpotlightTimer();
        if (!this.state.autoSwitchCurrentSecondary) return;
        const durationSeconds = Math.max(5, Number(this.state.autoSwitchSpotlightSeconds) || 0);
        const durationMs = durationSeconds * 1000;
        this.state.autoSwitchSpotlightEndsAt = Date.now() + durationMs;
        this.state.autoSwitchSpotlightTimer = setTimeout(()=>{
            this.state.autoSwitchSpotlightTimer = null;
            this.state.autoSwitchSpotlightEndsAt = null;
            this.finishSpotlightCycle();
        }, durationMs);
        this.refreshAutoSwitchCountdownDisplay();
    }
    finishSpotlightCycle() {
        if (!this.state.autoSwitchEnabled) {
            this.clearSpotlightState();
            return;
        }
        this.state.autoSwitchLastSecondary = this.state.autoSwitchCurrentSecondary;
        this.clearSpotlightState();
        this.activatePrimaryCamera();
        this.scheduleNextAutoSwitch();
    }
    stopAutoSwitchTimer({ resetState: resetState = true } = {}) {
        this.clearAutoSwitchTimer();
        this.clearSpotlightTimer();
        if (resetState) {
            this.clearSpotlightState();
            this.state.autoSwitchLastSecondary = null;
        }
    }
    clearAutoSwitchTimer() {
        if (this.state.autoSwitchTimer) {
            clearTimeout(this.state.autoSwitchTimer);
            this.state.autoSwitchTimer = null;
        }
        this.state.autoSwitchTimerEndsAt = null;
        this.refreshAutoSwitchCountdownDisplay();
    }
    clearSpotlightTimer() {
        if (this.state.autoSwitchSpotlightTimer) {
            clearTimeout(this.state.autoSwitchSpotlightTimer);
            this.state.autoSwitchSpotlightTimer = null;
        }
        this.state.autoSwitchSpotlightEndsAt = null;
        this.refreshAutoSwitchCountdownDisplay();
    }
    clearSpotlightState() {
        this.state.autoSwitchMode = "idle";
        this.state.autoSwitchCurrentSecondary = null;
    }
    activatePrimaryCamera() {
        const primaryIndex = this.getPrimaryCameraIndex();
        if (primaryIndex >= 0) {
            this.layoutManager.setActiveCameraIndex(primaryIndex);
            this.renderCameraPreviewGrid();
        }
    }
    hasSecondaryCameras() {
        return this.state.selectedCameras.length > 1;
    }
    pickNextSecondaryCamera() {
        if (!this.hasSecondaryCameras()) return null;
        const candidates = this.state.selectedCameras.filter((deviceId)=>deviceId !== this.state.primaryCameraId);
        if (!candidates.length) return null;
        if (candidates.length === 1) return candidates[0];
        const withoutLast = candidates.filter((deviceId)=>deviceId !== this.state.autoSwitchLastSecondary);
        const pool = withoutLast.length ? withoutLast : candidates;
        const randomIndex = Math.floor(Math.random() * pool.length);
        return pool[randomIndex];
    }
    getRandomAutoSwitchDelayMs() {
        const minMinutes = Number(this.state.autoSwitchMinMinutes) || $cb4d6b01942e8622$var$AUTO_SWITCH_MIN_DEFAULT;
        const maxMinutes = Number(this.state.autoSwitchMaxMinutes) || $cb4d6b01942e8622$var$AUTO_SWITCH_MAX_DEFAULT;
        const clampedMin = Math.max(1, Math.min(minMinutes, maxMinutes));
        const clampedMax = Math.max(clampedMin, maxMinutes);
        const minMs = clampedMin * 60000;
        const maxMs = clampedMax * 60000;
        const range = maxMs - minMs;
        if (range <= 0) return minMs;
        return minMs + Math.floor(Math.random() * range);
    }
    beforeUnloadHandler(event) {
        if (this.state.isRecording) {
            event.preventDefault();
            event.returnValue = "Registrazione in corso. Se chiudi la pagina, potresti perdere il video.";
            return event.returnValue;
        }
    }
    async checkRecoveryOnStartup() {
    // No-op
    }
    registerRecoveryControls() {
    // Disabled recovery controls
    }
}


const $7e9b890460e54f64$export$c467f761142dde0c = ()=>{
    const isMobileRegExp = /mobile|android|iphone/i;
    const isMobile = isMobileRegExp.test(navigator.userAgent);
    if (isMobile) alert("Sorry, we don't support mobile devices yet \uD83E\uDD7A");
};


window.addEventListener("load", ()=>(0, $7e9b890460e54f64$export$c467f761142dde0c)());
const $85a5f86b715fe7db$var$screenRec = {};
//instance
$85a5f86b715fe7db$var$screenRec.recorder = new (0, $cb4d6b01942e8622$export$2e2bcd8739ae039)();
// init
$85a5f86b715fe7db$var$screenRec.recorder.init();


//# sourceMappingURL=screenREC.7a04e15f.js.map
